{
  "analysis.modes.query.label": "Zoekopdracht",
  "analysis.modes.query.description": "Standard analyse (enkele of meerdere-query)",
  "analysis.modes.funnel.label": "Trechter",
  "analysis.modes.funnel.description": "Sequential conversion analyse",
  "analysis.modes.flow.label": "Stroom",
  "analysis.modes.flow.description": "Bidirectional pad analyse met Sankey visualisatie",
  "analysis.modes.retention.label": "Retentie",
  "analysis.modes.retention.description": "Cohortgebaseerde retentieanalyse over tijdsperioden",
  "analysis.ai.title": "AI-querygenerator",
  "analysis.ai.generating": "Genereren...",
  "analysis.ai.placeholder": "Beschrijf je query in natuurlijke taal... (bijv. 'Toon totale verkoop per maand voor het afgelopen jaar')",
  "analysis.ai.shortcutHint": "Druk op Enter om te genereren, Shift+Enter voor een nieuwe regel",
  "analysis.ai.successMessage": "Query gegenereerd en geladen! Controleer de resultaten hieronder en klik op Accepteren om te behouden of Annuleren om terug te draaien.",
  "analysis.ai.button.accept": "Accepteren",
  "analysis.ai.button.cancel": "Annuleren",
  "analysis.ai.button.close": "Sluiten",
  "analysis.ai.button.generate": "Genereren",
  "analysis.ai.button.generating": "Genereren...",
  "analysis.sections.metrics": "Metrieken",
  "analysis.sections.breakdown": "Opsplitsing",
  "analysis.sections.dimensions": "Dimensies",
  "analysis.sections.filters": "Filter",
  "analysis.sections.limit": "Limiet",
  "analysis.tabs.query": "Zoekopdracht",
  "analysis.tabs.chart": "Grafiek",
  "analysis.tabs.chartTitle": "Grafiek configuratie",
  "analysis.tabs.display": "Weergave",
  "analysis.tabs.displayTitle": "Weergave options",
  "analysis.multiQuery.removeQuery": "Verwijderen query",
  "analysis.multiQuery.addQuery": "Voeg new query",
  "analysis.multiQuery.addAnother": "Voeg another query",
  "analysis.multiQuery.mergeExplanation": "In samenvoegen modus, dimensies zijn shared van Q1.",
  "analysis.multiQuery.switchToSeparate": "Schakel naar aparte reeksen",
  "analysis.mergeStrategy.concat": "Apart reeksen",
  "analysis.mergeStrategy.merge": "Samenvoegen op dimensie",
  "analysis.mergeStrategy.funnel": "Trechter",
  "analysis.placeholders.addMetrics": "Voeg metingen toe om SQL te genereren",
  "analysis.placeholders.hoverField": "Beweeg over een veld om details te zien",
  "analysis.placeholders.noData": "Geen gegevens beschikbaar",
  "common.actions.accept": "Accepteren",
  "common.actions.cancel": "Annuleren",
  "common.actions.delete": "Verwijderen",
  "common.actions.close": "Sluiten",
  "common.actions.edit": "Bewerken",
  "common.actions.save": "Opslaan",
  "common.actions.copy": "Kopiëren",
  "common.actions.duplicate": "Dupliceren",
  "common.actions.refresh": "Vernieuwen",
  "common.actions.confirm": "Bevestigen",
  "common.actions.add": "Voeg",
  "common.actions.clear": "Wissen",
  "common.actions.select": "Selecteer",
  "common.actions.navigate": "Navigeer",
  "common.actions.share": "Delen",
  "common.loading": "Laden...",
  "common.modal.processing": "Verwerken...",
  "common.modal.dashboardName": "Dashboard Naam",
  "common.modal.deleteConfirmation": "Weet je het zeker? Deze actie kan niet ongedaan worden gemaakt.",
  "common.sorting.ascending": "Oplopend gesorteerd (klik voor aflopend)",
  "common.sorting.descending": "Aflopend gesorteerd (klik om te verwijderen)",
  "common.sorting.none": "Klik om oplopend te sorteren",
  "fieldTypes.count": "Aantal",
  "fieldTypes.countDistinct": "Aantal Distinct",
  "fieldTypes.countDistinctApprox": "Aantal Distinct (Approx)",
  "fieldTypes.sum": "Som",
  "fieldTypes.avg": "Gemiddelde",
  "fieldTypes.min": "Minimum",
  "fieldTypes.max": "Maximum",
  "fieldTypes.runningTotal": "Uitvoeren Totaal",
  "fieldTypes.number": "Nummer",
  "fieldTypes.string": "Tekst",
  "fieldTypes.boolean": "Boolean",
  "fieldTypes.time": "Tijd Dimensie",
  "fieldTypes.geo": "Geografisch",
  "fieldTypes.dimension": "Dimensie",
  "fieldPanel.emptyState": "Beweeg over een veld om details te zien",
  "fieldPanel.usageHint": "Druk op Enter of klik om dit veld aan je query toe te voegen.",
  "fieldPanel.labels.type": "Type",
  "fieldPanel.labels.cube": "Cube",
  "fieldPanel.labels.category": "Categorie",
  "fieldCategory.measure": "Meting",
  "fieldCategory.timeDimension": "Tijd Dimensie",
  "fieldCategory.dimension": "Dimensie",
  "fieldSearch.placeholder.metrics": "Zoeken metingen...",
  "fieldSearch.placeholder.filter": "Zoeken velden naar filter...",
  "fieldSearch.placeholder.dimensions": "Zoeken dimensies...",
  "fieldSearch.modal.title.metrics": "Selecteer a Metric",
  "fieldSearch.modal.title.filter": "Selecteer a Veld naar Filter",
  "fieldSearch.modal.title.dimensions": "Selecteer a Dimensie",
  "fieldSearch.filter.allCubes": "Alle Cubes",
  "fieldSearch.categories.all": "Alle",
  "fieldSearch.empty.heading": "Geen velden gevonden",
  "fieldSearch.empty.noMatchMetrics": "Geen metingen match \"{searchTerm}\"",
  "fieldSearch.empty.noMatchDimensions": "Geen dimensies match \"{searchTerm}\"",
  "fieldSearch.empty.noMetrics": "Geen metingen beschikbaar",
  "fieldSearch.empty.noDimensions": "Geen dimensies beschikbaar",
  "fieldSearch.section.recents": "Recent",
  "fieldSearch.footer.metricsAvailable": "metrieken beschikbaar",
  "fieldSearch.footer.fieldsAvailable": "velden beschikbaar",
  "fieldSearch.footer.dimensionsAvailable": "dimensies beschikbaar",
  "fieldSearch.shortcut.navigate": "Navigeer",
  "fieldSearch.shortcut.keyEnter": "Enter",
  "fieldSearch.shortcut.keyShift": "Shift",
  "fieldSearch.shortcut.keyEsc": "Esc",
  "fieldSearch.shortcut.plusClick": "+Klik",
  "fieldSearch.shortcut.select": "Selecteer",
  "fieldSearch.shortcut.multiSelect": "Meerdere-selecteer",
  "fieldSearch.shortcut.close": "Sluiten",
  "filter.group.condition": "voorwaarde",
  "filter.group.conditions": "voorwaarden",
  "filter.group.addFilter": "Voeg Filter",
  "filter.group.addAndGroup": "Voeg EN Groep",
  "filter.group.addOrGroup": "Voeg OF Groep",
  "filter.group.removeGroup": "Verwijderen groep",
  "filter.group.empty": "Geen conditions in deze groep",
  "filter.group.addFilterLink": "Voeg a filter",
  "filter.modal.title": "Bewerken Filter",
  "filter.modal.fieldLabel": "Veld",
  "filter.modal.operatorLabel": "Operator",
  "filter.modal.valueLabel": "Waarde",
  "filter.modal.selectRange": "Selecteer range",
  "filter.modal.noValueRequired": "Geen waarde vereist",
  "filter.modal.dateTo": "naar",
  "filter.modal.min": "Min",
  "filter.modal.to": "naar",
  "filter.modal.max": "Max",
  "filter.modal.enterNumber": "Enter nummer",
  "filter.modal.loading": "Laden...",
  "filter.modal.selectValue": "Selecteer waarde...",
  "filter.modal.search": "Zoeken...",
  "filter.modal.errorPrefix": "Fout:",
  "filter.modal.noValues": "Geen waarden gevonden",
  "filter.modal.multiSelectHint": "Houd Shift ingedrukt om meerdere waarden te selecteren",
  "filter.modal.enterValue": "Enter waarde...",
  "filter.removeButton.title": "Verwijderen filter",
  "filter.section.clearAll": "Wissen alle",
  "filter.section.dropHint": "Sleep hierheen om filter toe te voegen",
  "filter.section.empty": "Geen filters toegepast",
  "filter.valueDisplay.empty": "(leeg)",
  "filter.valueDisplay.more": "meer",
  "filter.operator.equals.label": "gelijk aan",
  "filter.operator.equals.description": "Exacte overeenkomst",
  "filter.operator.notEquals.label": "niet gelijk aan",
  "filter.operator.notEquals.description": "Komt niet overeen",
  "filter.operator.contains.label": "bevat",
  "filter.operator.contains.description": "Bevat tekst (hoofdletterongevoelig)",
  "filter.operator.notContains.label": "niet bevat",
  "filter.operator.notContains.description": "Bevat geen tekst",
  "filter.operator.startsWith.label": "begint met",
  "filter.operator.startsWith.description": "Begint met tekst",
  "filter.operator.notStartsWith.label": "niet begint met",
  "filter.operator.notStartsWith.description": "Begint niet met tekst",
  "filter.operator.endsWith.label": "eindigt met",
  "filter.operator.endsWith.description": "Eindigt met tekst",
  "filter.operator.notEndsWith.label": "niet eindigt met",
  "filter.operator.notEndsWith.description": "Eindigt niet met tekst",
  "filter.operator.like.label": "like",
  "filter.operator.like.description": "SQL LIKE pattern overeenkomstige (hoofdletter gevoelig)",
  "filter.operator.notLike.label": "niet like",
  "filter.operator.notLike.description": "SQL NIET LIKE pattern overeenkomstige (hoofdletter gevoelig)",
  "filter.operator.ilike.label": "ilike",
  "filter.operator.ilike.description": "SQL ILIKE pattern overeenkomstige (hoofdletter ongevoelig)",
  "filter.operator.gt.label": "groter dan",
  "filter.operator.gt.description": "Groter dan waarde",
  "filter.operator.gte.label": "groter dan van gelijk",
  "filter.operator.gte.description": "Groter dan van gelijk naar waarde",
  "filter.operator.lt.label": "kleiner dan",
  "filter.operator.lt.description": "Kleiner dan waarde",
  "filter.operator.lte.label": "kleiner dan van gelijk",
  "filter.operator.lte.description": "Kleiner dan van gelijk naar waarde",
  "filter.operator.between.label": "tussen",
  "filter.operator.between.description": "Tussen twee waarden (inclusive)",
  "filter.operator.notBetween.label": "niet tussen",
  "filter.operator.notBetween.description": "Niet tussen twee waarden",
  "filter.operator.in.label": "in",
  "filter.operator.in.description": "Komt overeen elke van de opgegeven waarden",
  "filter.operator.notIn.label": "niet in",
  "filter.operator.notIn.description": "Komt niet overeen elke van de opgegeven waarden",
  "filter.operator.set.label": "is set",
  "filter.operator.set.description": "Is niet nul/leeg",
  "filter.operator.notSet.label": "is niet set",
  "filter.operator.notSet.description": "Is nul/leeg",
  "filter.operator.isEmpty.label": "is leeg",
  "filter.operator.isEmpty.description": "Is leeg tekenreeks van nul",
  "filter.operator.isNotEmpty.label": "is niet leeg",
  "filter.operator.isNotEmpty.description": "Is niet leeg tekenreeks en niet nul",
  "filter.operator.inDateRange.label": "in datum bereik",
  "filter.operator.inDateRange.description": "Tussen twee dates",
  "filter.operator.beforeDate.label": "voor datum",
  "filter.operator.beforeDate.description": "Voor opgegeven datum",
  "filter.operator.afterDate.label": "na datum",
  "filter.operator.afterDate.description": "Na opgegeven datum",
  "filter.operator.regex.label": "komt overeen regex",
  "filter.operator.regex.description": "Komt overeen reguliere expressie pattern",
  "filter.operator.notRegex.label": "niet komt overeen regex",
  "filter.operator.notRegex.description": "Komt niet overeen reguliere expressie pattern",
  "filter.operator.arrayContains.label": "array bevat alle",
  "filter.operator.arrayContains.description": "Array veld bevat alle opgegeven waarden (PostgreSQL alleen)",
  "filter.operator.arrayOverlaps.label": "array bevat elke",
  "filter.operator.arrayOverlaps.description": "Array veld bevat elke van de opgegeven waarden (PostgreSQL alleen)",
  "filter.operator.arrayContained.label": "array waarden in",
  "filter.operator.arrayContained.description": "Alle array veld waarden vallen binnen specified waarden (PostgreSQL only)",
  "dateRange.custom": "Aangepast",
  "dateRange.today": "Vandaag",
  "dateRange.yesterday": "Gisteren",
  "dateRange.thisWeek": "Deze week",
  "dateRange.thisMonth": "Deze maand",
  "dateRange.thisQuarter": "Deze quarter",
  "dateRange.thisYear": "Deze jaar",
  "dateRange.last7Days": "Laatste 7 days",
  "dateRange.last30Days": "Laatste 30 days",
  "dateRange.lastNDays": "Laatste N days",
  "dateRange.lastWeek": "Laatste week",
  "dateRange.lastNWeeks": "Laatste N weeks",
  "dateRange.lastMonth": "Laatste month",
  "dateRange.last12Months": "Laatste 12 months",
  "dateRange.lastNMonths": "Laatste N months",
  "dateRange.lastQuarter": "Laatste quarter",
  "dateRange.lastNQuarters": "Laatste N quarters",
  "dateRange.lastYear": "Laatste jaar",
  "dateRange.lastNYears": "Laatste N years",
  "timeGranularity.hour": "Uur",
  "timeGranularity.day": "Dag",
  "timeGranularity.week": "Week",
  "timeGranularity.month": "Maand",
  "timeGranularity.quarter": "Kwartaal",
  "timeGranularity.year": "Jaar",
  "query.limit.label": "Limiet",
  "query.limit.clear": "Wissen",
  "chart.bar.label": "Staaf Grafiek",
  "chart.bar.description": "Vergelijk waarden over categorieën",
  "chart.bar.useCase": "Beste voor het vergelijken van discrete categorieën, het tonen van ranglijsten of het weergeven van wijzigingen in de tijd",
  "chart.line.label": "Lijn Grafiek",
  "chart.line.description": "Toon trends en wijzigingen in de tijd",
  "chart.line.useCase": "Beste voor doorlopende gegevens, trends, time reeksen, en toont relationships tussen multiple reeksen",
  "chart.area.label": "Area Grafiek",
  "chart.area.description": "Benadruk de omvang van veranderingen in de tijd",
  "chart.area.useCase": "Beste voor het tonen van cumulatieve totalen, volumewijzigingen of gestapelde vergelijkingen in de tijd",
  "chart.pie.label": "Taart Grafiek",
  "chart.pie.description": "Toon proportions of a whole",
  "chart.pie.useCase": "Beste voor toont percentage distribution of composition of a totaal (limit naar 5-7 slices)",
  "chart.scatter.label": "Spreiding Plot",
  "chart.scatter.description": "Reveal correlations tussen variables",
  "chart.scatter.useCase": "Beste voor identifying patterns, correlations, outliers, en relationships tussen two metingen",
  "chart.bubble.label": "Bubble Grafiek",
  "chart.bubble.description": "Vergelijk three dimensies of gegevens",
  "chart.bubble.useCase": "Beste voor toont relationships tussen three variables (X, Y, en size), market analyse",
  "chart.radar.label": "Radar Grafiek",
  "chart.radar.description": "Vergelijk meerdere metingen over categorieën",
  "chart.radar.useCase": "Beste voor multivariate comparisons, prestatie metingen, strengths/weaknesses analyse",
  "chart.radialBar.label": "Radial Staaf Grafiek",
  "chart.radialBar.description": "Circular voortgang en KPI visualisatie",
  "chart.radialBar.useCase": "Beste voor toont voortgang toward doelen, KPIs, of comparing percentages in a compact form",
  "chart.treemap.label": "Boomkaart",
  "chart.treemap.description": "Visualise hierarchical gegevens met nested rectangles",
  "chart.treemap.useCase": "Beste voor toont part-naar-whole relationships in hierarchical gegevens, disk usage, budget allocation",
  "chart.table.label": "Gegevens Tabel",
  "chart.table.description": "Weergave gedetailleerde tabular gegevens",
  "chart.table.useCase": "Beste voor precise waarden, gedetailleerde analyse, sortable/filterable gegevens exploration",
  "chart.activityGrid.label": "Activiteit Raster",
  "chart.activityGrid.description": "GitHub-stijl activiteitenraster dat temporele patronen over verschillende tijdschalen toont",
  "chart.activityGrid.useCase": "Beste voor het visualiseren van activiteitspatronen in de tijd. Ondersteunt uur (3-uursblokken × dagen), dag (dagen × weken), week (weken × maanden), maand (maanden × kwartalen) en kwartaal (kwartalen × jaren) granulariteit",
  "chart.kpiNumber.label": "KPI Nummer",
  "chart.kpiNumber.description": "Weergave key prestatie indicators as large numbers",
  "chart.kpiNumber.useCase": "Perfect voor toont belangrijk metrieken like omzet, gebruiker aantal, van andere sleutel business metrieken in een prominent, easy-naar-read format",
  "chart.kpiDelta.label": "KPI-delta",
  "chart.kpiDelta.description": "Weergave change tussen latest en previous waarden met trend indicators",
  "chart.kpiDelta.useCase": "Ideaal voor het tonen van prestatieveranderingen in de tijd, zoals omzetgroei, wijzigingen in gebruikersacquisitie en andere metrieken waarbij trend en delta belangrijker zijn dan de absolute waarde",
  "chart.kpiText.label": "KPI Tekst",
  "chart.kpiText.description": "Weergave key prestatie indicators as customisable text",
  "chart.kpiText.useCase": "Perfect voor toont metrieken met custom formatting, combining meerdere waarden, van displaying contextual KPI information met templates",
  "chart.markdown.label": "Markdown",
  "chart.markdown.description": "Weergave custom markdown content met formatting",
  "chart.markdown.useCase": "Perfect voor adding documentation, notes, section kopteksten, instructions, van formatted tekst naar dashboards",
  "chart.funnel.label": "Funnel Grafiek",
  "chart.funnel.description": "Toon conversion through sequential stappen",
  "chart.funnel.useCase": "Beste voor visualiseren user journey funnels, verkoop pipelines, of meerdere-stap processes",
  "chart.sankey.label": "Sankey Grafiek",
  "chart.sankey.description": "Toon flow tussen states of stappen",
  "chart.sankey.useCase": "Beste voor visualiseren user journey flows, pad analyse, of state transitions",
  "chart.sunburst.label": "Sunburst Grafiek",
  "chart.sunburst.description": "Toon hierarchical flow as radial rings",
  "chart.sunburst.useCase": "Beste voor visualiseren forward paden van a startende gebeurtenis in a compact radial layout",
  "chart.heatmap.label": "Heatmap",
  "chart.heatmap.description": "Visualiseer intensiteit over twee dimensies",
  "chart.heatmap.useCase": "Beste voor toont patterns in matrix gegevens like correlations, schedules, of categorie comparisons",
  "chart.retentionHeatmap.label": "Retentie Matrix",
  "chart.retentionHeatmap.description": "Cohort retentie matrix visualisatie",
  "chart.retentionHeatmap.useCase": "Visualiseer gebruikersretentie in de tijd per cohort",
  "chart.retentionCombined.label": "Retentie Grafiek",
  "chart.retentionCombined.description": "Combined retentie visualisatie met lijngrafiek en heatmap modes",
  "chart.retentionCombined.useCase": "Visualiseer gebruikersretentie in de tijd met optionele segmentatie naar uitsplitsing",
  "chart.boxPlot.label": "Boxplot",
  "chart.boxPlot.description": "Toon statistische verdeling (mediaan, IQR, whiskers) over categorieën",
  "chart.boxPlot.useCase": "Beste voor P&L-spreiding per symbool, verdeling van handelsgrootte en latentieverdeling over platforms",
  "chart.waterfall.label": "Waterfall Grafiek",
  "chart.waterfall.description": "Toon cumulative effect of sequential positive en negative waarden",
  "chart.waterfall.useCase": "Beste voor P&L decomposition, cash flow analyse, budget variance, of elke sequential contribution breakdown",
  "chart.candlestick.label": "Candlestick Grafiek",
  "chart.candlestick.description": "Financial candlestick grafiek toont openen/sluiten body en hoog/laag wicks",
  "chart.candlestick.useCase": "Beste voor EOD quotes (bid/ask spread per date/symbol), markout distribution bands, of OHLC price gegevens",
  "chart.measureProfile.label": "Meting Profile",
  "chart.measureProfile.description": "Plot N metingen als opeenvolgende X-aspunten om een profiel of vorm over intervallen te visualiseren",
  "chart.measureProfile.useCase": "Beste voor markout-intervalanalyse (bijv. avgMinus2m → avgAtEvent → avgPlus2h), metricprofielen of elk patroon over geordende metingen",
  "chart.gauge.label": "Gauge Grafiek",
  "chart.gauge.description": "Half-circle arc meter voor een enkele KPI waarde versus een maximum target",
  "chart.gauge.useCase": "Beste voor hoogwatermerken vs equity, margin utilisation, of elke enkele waarde voortgang toward a doel",
  "chart.config.chartType": "Grafiek Type",
  "chart.config.loading": "Laden grafiek configuratie...",
  "chart.config.axisConfig": "Grafiek Configuration",
  "chart.config.unassigned": "Unassigned Velden",
  "chart.config.unassignedHint": "Drag velden naar grafiek axes above",
  "chart.config.noFields": "Voeg metingen en uitsplitsingen toe in het tabblad Query om grafiekassen te configureren",
  "chart.dropZone.xAxis.label": "X-As (Categorieën)",
  "chart.dropZone.xAxis.description": "Dimensies en time dimensies voor grouping",
  "chart.dropZone.xAxis.empty": "Sleep dimensies & tijd dimensies hier",
  "chart.dropZone.yAxis.label": "Y-As (Waarden)",
  "chart.dropZone.yAxis.description": "Metingen voor waarden of dimensies voor reeksen",
  "chart.dropZone.yAxis.empty": "Sleep metingen van dimensies hier",
  "chart.dropZone.series.label": "Reeks (Splits naar Multiple Reeks)",
  "chart.dropZone.series.description": "Dimensies naar create separate gegevens reeksen",
  "chart.dropZone.series.empty": "Sleep dimensies hier naar splits gegevens naar reeksen",
  "chart.dropZone.maxReached": "Maximaal aantal items bereikt",
  "chart.dropZone.default.empty": "Sleep velden hierheen",

  "chart.bar.dropZone.xAxis.empty": "Sleep dimensies & tijdsdimensies hierheen",
  "chart.bar.dropZone.yAxis.empty": "Sleep metingen hierheen",
  "chart.bar.dropZone.series.empty": "Sleep dimensies hierheen om gegevens in reeksen te splitsen",
  "chart.line.dropZone.xAxis.empty": "Sleep tijdsdimensies of dimensies hierheen",
  "chart.line.dropZone.yAxis.empty": "Sleep metingen hierheen",
  "chart.line.dropZone.series.empty": "Sleep dimensies hierheen voor meerdere lijnen",
  "chart.area.dropZone.xAxis.empty": "Sleep tijdsdimensies of dimensies hierheen",
  "chart.area.dropZone.yAxis.empty": "Sleep metingen hierheen",
  "chart.area.dropZone.series.empty": "Sleep dimensies hierheen voor gestapelde gebieden",
  "chart.pie.dropZone.xAxis.empty": "Sleep een dimensie voor categorieën",
  "chart.pie.dropZone.yAxis.empty": "Sleep een meting voor waarden",
  "chart.scatter.dropZone.xAxis.empty": "Sleep een veld voor X-as",
  "chart.scatter.dropZone.yAxis.empty": "Sleep een meting voor Y-as",
  "chart.scatter.dropZone.series.empty": "Sleep een dimensie om punten te kleuren",
  "chart.bubble.dropZone.xAxis.empty": "Sleep een veld voor X-aspositie",
  "chart.bubble.dropZone.yAxis.empty": "Sleep een meting voor Y-aspositie",
  "chart.bubble.dropZone.sizeField.empty": "Sleep een meting voor bellengrootte",
  "chart.bubble.dropZone.series.empty": "Sleep een dimensie voor bellenlabels",
  "chart.bubble.dropZone.colorField.empty": "Sleep een veld voor bellenkleur (optioneel)",
  "chart.radar.dropZone.xAxis.empty": "Sleep dimensies voor radarassen",
  "chart.radar.dropZone.yAxis.empty": "Sleep metingen voor waarden",
  "chart.radar.dropZone.series.empty": "Sleep dimensies voor meerdere vormen",
  "chart.radialBar.dropZone.xAxis.empty": "Sleep dimensies voor categorieën",
  "chart.radialBar.dropZone.yAxis.empty": "Sleep een meting voor waarden",
  "chart.treemap.dropZone.xAxis.empty": "Sleep dimensies voor categorieën",
  "chart.treemap.dropZone.yAxis.empty": "Sleep een meting voor grootte",
  "chart.treemap.dropZone.series.empty": "Sleep een dimensie voor kleurgroepering",
  "chart.table.dropZone.xAxis.empty": "Sleep velden om als kolommen weer te geven (of laat leeg voor alles)",
  "chart.activityGrid.dropZone.dateField.empty": "Sleep een tijdsdimensie (granulariteit beïnvloedt rasterstructuur)",
  "chart.activityGrid.dropZone.valueField.empty": "Sleep een meting voor activiteitsintensiteit",
  "chart.kpiNumber.dropZone.yAxis.empty": "Sleep een meting hierheen",
  "chart.kpiDelta.dropZone.yAxis.empty": "Sleep een meting hierheen",
  "chart.kpiDelta.dropZone.xAxis.empty": "Sleep een dimensie voor ordening",
  "chart.kpiText.dropZone.yAxis.empty": "Sleep een meting hierheen",
  "chart.funnel.dropZone.xAxis.empty": "Stappen gedefinieerd in trechterconfig",
  "chart.funnel.dropZone.yAxis.empty": "Tellingen berekend uit trechteruitvoering",
  "chart.sankey.dropZone.xAxis.empty": "Automatisch ingevuld vanuit stroomconfig",
  "chart.sankey.dropZone.yAxis.empty": "Berekend vanuit stroomuitvoering",
  "chart.sunburst.dropZone.xAxis.empty": "Automatisch ingevuld vanuit stroomconfig",
  "chart.sunburst.dropZone.yAxis.empty": "Berekend vanuit stroomuitvoering",
  "chart.heatmap.dropZone.xAxis.empty": "Sleep één dimensie hierheen",
  "chart.heatmap.dropZone.yAxis.empty": "Sleep één dimensie hierheen",
  "chart.heatmap.dropZone.valueField.empty": "Sleep één meting hierheen",
  "chart.boxPlot.dropZone.xAxis.empty": "Sleep een dimensie hierheen",
  "chart.boxPlot.dropZone.yAxis.empty": "Sleep 1, 3 of 5 metingen hierheen",
  "chart.waterfall.dropZone.xAxis.empty": "Sleep een dimensie hierheen",
  "chart.waterfall.dropZone.yAxis.empty": "Sleep een meting hierheen",
  "chart.candlestick.dropZone.xAxis.empty": "Sleep een tijd- of dimensie hierheen",
  "chart.candlestick.dropZone.yAxis.empty": "Sleep 2+ metingen hierheen",
  "chart.measureProfile.dropZone.yAxis.empty": "Sleep 2+ metingen hierheen (weergegeven links → rechts)",
  "chart.measureProfile.dropZone.series.empty": "Sleep een dimensie hierheen om meerdere lijnen te maken",
  "chart.gauge.dropZone.yAxis.empty": "Sleep 1 meting hierheen (optioneel 2e voor dynamisch max)",

  "chart.activityGrid.validation.timeDimensionRequired": "Tijdsdimensie is vereist voor activiteitsraster",
  "chart.activityGrid.validation.measureRequired": "Activiteitsmeting is vereist voor intensiteitstoewijzing",
  "chart.kpiDelta.validation.measureRequired": "Een meting is vereist voor KPI Delta-grafieken",
  "chart.heatmap.validation.xAxisRequired": "X-as dimensie vereist",
  "chart.heatmap.validation.yAxisRequired": "Y-as dimensie vereist",
  "chart.heatmap.validation.valueRequired": "Waardemeting vereist",

  "chart.option.stacking.label": "Stapeling",
  "chart.option.stacking.none": "Geen",
  "chart.option.stacking.stacked": "Gestapeld",
  "chart.option.stacking.percent": "Gestapeld 100%",
  "chart.option.stacking.description": "Hoe naar stack meerdere reeksen",
  "chart.option.target.label": "Doelwaardes",
  "chart.option.target.description": "Enkele waarde of door komma's gescheiden waarden om over de X-as te spreiden",
  "chart.option.connectNulls.label": "Verbind null-waarden",
  "chart.option.connectNulls.description": "Tekenen doorlopende regel through ontbrekend gegevens punten",
  "chart.option.showAllXLabels.label": "Toon alle X-labels",
  "chart.option.showAllXLabels.description": "Toon elk label op de X-as in plaats van overlappende labels automatisch te verbergen",
  "chart.option.leftYAxisFormat.label": "Left Y-As Format",
  "chart.option.leftYAxisFormat.description": "Nummer formatting voor left Y-axis",
  "chart.option.rightYAxisFormat.label": "Right Y-As Format",
  "chart.option.rightYAxisFormat.description": "Nummer formatting voor right Y-axis",
  "chart.option.xAxisFormat.label": "X-As Format",
  "chart.option.xAxisFormat.description": "Nummer formatting voor X-axis",
  "chart.option.yAxisFormat.label": "Y-As Format",
  "chart.option.yAxisFormat.description": "Nummer formatting voor Y-axis",
  "chart.option.valueFormat.label": "Waarde Format",
  "chart.option.valueFormat.description": "Nummer formatting voor waarden",
  "chart.option.innerRadius.label": "Binnenradius",
  "chart.option.innerRadius.description": "Hollow centre grootte (0% = solid pie, higher = donut style)",
  "chart.option.showLabels.label": "Toon Cell Waarden",
  "chart.option.showLabels.description": "Weergave waarden inside each cell",
  "chart.option.cellShape.label": "Celvorm",
  "chart.option.cellShape.rectangle": "Rechthoek",
  "chart.option.cellShape.circle": "Cirkel",
  "chart.option.funnelStyle.label": "Trechterstijl",
  "chart.option.funnelStyle.bars": "Balken",
  "chart.option.funnelStyle.funnel": "Trechter",
  "chart.option.funnelOrientation.label": "Oriëntatie",
  "chart.option.funnelOrientation.horizontal": "Horizontaal",
  "chart.option.funnelOrientation.vertical": "Verticaal",
  "chart.option.hideSummaryFooter.label": "Verbergen Samenvatting Footer",
  "chart.option.hideSummaryFooter.description": "Verberg de samenvattingsfooter die het aantal stappen en de totale conversie toont",
  "chart.option.showConversion.label": "Toon Conversion Rate",
  "chart.option.showConversion.description": "Weergave stap-naar-stap conversion percentage",
  "chart.option.showAvgTime.label": "Toon Avg Tijd",
  "chart.option.showAvgTime.description": "Weergave average time naar convert",
  "chart.option.showMedianTime.label": "Toon Median Tijd",
  "chart.option.showMedianTime.description": "Weergave median time naar convert",
  "chart.option.showP90Time.label": "Toon P90 Tijd",
  "chart.option.showP90Time.description": "Weergave 90th percentile time naar convert",
  "chart.option.linkOpacity.label": "Link-opaciteit",
  "chart.option.linkOpacity.light": "Licht",
  "chart.option.linkOpacity.medium": "Gemiddeld",
  "chart.option.linkOpacity.dark": "Donker",
  "chart.option.showNodeLabels.label": "Toon Node Labels",
  "chart.option.showNodeLabels.description": "Weergave labels on flow nodes",
  "chart.option.prefix.label": "Voorvoegsel",
  "chart.option.prefix.description": "Tekst om vóór het getal weer te geven",
  "chart.option.suffix.label": "Achtervoegsel",
  "chart.option.suffix.description": "Tekst om na het getal weer te geven",
  "chart.option.decimals.label": "Aantal decimalen",
  "chart.option.decimals.description": "Nummer of decimal places naar weergeven",
  "chart.option.showHistogram.label": "Toon Variance Histogram",
  "chart.option.showHistogram.description": "Toon historische variantiegrafiek onder de delta",
  "chart.option.useLastCompletePeriod.label": "Gebruik Laatste Voltooid Periode",
  "chart.option.useLastCompletePeriod.description": "Exclude current incomplete periode van calculation (e.g., partial week/maand)",
  "chart.option.skipLastPeriod.label": "Skip Laatste Periode",
  "chart.option.skipLastPeriod.description": "Always exclude de laatste periode regardless van completeness",
  "chart.option.retentionDisplayMode.label": "Weergave Mode",
  "chart.option.retentionDisplayMode.lineChart": "Lijn Grafiek",
  "chart.option.retentionDisplayMode.heatmapTable": "Heatmap Tabel",
  "chart.option.retentionDisplayMode.combined": "Gecombineerd",
  "chart.option.showLegend.label": "Toon Legenda",
  "chart.option.showLegend.description": "Toon de legenda",
  "chart.option.showGrid.label": "Toon Grid",
  "chart.option.showGrid.description": "Toon rasterlijnen op de grafiek",
  "chart.option.showTooltip.label": "Toon Tooltip",
  "chart.option.showTooltip.description": "Toon tooltip on zweef met gedetailleerde stats",
  "chart.option.priorPeriodStyle.label": "Prior Periode Lijn Style",
  "chart.option.priorPeriodStyle.dashed": "Gestreept",
  "chart.option.priorPeriodStyle.dotted": "Gestippeld",
  "chart.option.priorPeriodStyle.solid": "Vol",
  "chart.option.priorPeriodStyle.description": "Lijn style voor prior period in comparison mode",
  "chart.option.priorPeriodOpacity.label": "Prior Periode Opacity",
  "chart.option.priorPeriodOpacity.description": "Opacity voor prior periode lines (0.1 naar 1)",
  "chart.option.showTotal.label": "Toon Totaal Staaf",
  "chart.option.showTotal.description": "Append een final staaf toont de draaiend totaal",
  "chart.option.showConnectorLine.label": "Toon Connector Lijn",
  "chart.option.showConnectorLine.description": "Tekenen een dashed stap-regel connecting staaf tops",
  "chart.option.showDataLabels.label": "Toon Gegevens Labels",
  "chart.option.showDataLabels.description": "Toon de waarde bij elk datapunt",
  "chart.option.showReferenceLineAtZero.label": "Toon Zero Reference Lijn",
  "chart.option.showReferenceLineAtZero.description": "Tekenen een dashed regel bij Y = 0",
  "chart.option.lineType.label": "Lijn Interpolation",
  "chart.option.lineType.smooth": "Vloeiend (monotoon)",
  "chart.option.lineType.linear": "Lineair",
  "chart.option.lineType.step": "Stap",
  "chart.option.lineType.description": "Hoe gegevens punten zijn connected",
  "chart.option.rangeMode.label": "Grafiek Mode",
  "chart.option.rangeMode.ohlc": "OHLC (openen, sluiten, hoog, laag)",
  "chart.option.rangeMode.range": "Bereik (hoog, laag / bid, ask)",
  "chart.option.rangeMode.description": "OHLC: 4 metingen. Bereik: 2 metingen (hoog + laag).",
  "chart.option.bullColor.label": "Bullish Kleur",
  "chart.option.bullColor.description": "Candle kleur when sluiten ≥ openen",
  "chart.option.bearColor.label": "Bearish Kleur",
  "chart.option.bearColor.description": "Candle kleur when sluiten < openen",
  "chart.option.showWicks.label": "Toon Wicks",
  "chart.option.showWicks.description": "Tekenen hoog/laag wicks above en onder de body",
  "chart.option.minValue.label": "Minimum Waarde",
  "chart.option.minValue.description": "Lower bound van de meter arc (standaard 0)",
  "chart.option.maxValue.label": "Maximum Waarde (static)",
  "chart.option.maxValue.description": "Upper bound van de meter. Leave leeg naar use yAxis[1] van standaard 100",
  "chart.option.showCentreLabel.label": "Toon Centre Label",
  "chart.option.showCentreLabel.description": "Toon huidige waarde en veldnaam in het midden van de gauge",
  "chart.option.showPercentage.label": "Toon as Percentage",
  "chart.option.showPercentage.description": "Weergave waarde as % of max instead of raw number",
  "chart.option.fitToWidth.label": "Fit naar Width",
  "chart.option.fitToWidth.description": "Automatically grootte blocks naar fill portlet width en hoogte while maintaining aspect ratio",
  "chart.option.fontSize.label": "Font Grootte",
  "chart.option.fontSize.small": "Klein",
  "chart.option.fontSize.medium": "Gemiddeld",
  "chart.option.fontSize.large": "Groot",
  "chart.option.alignment.label": "Tekst Alignment",
  "chart.option.alignment.left": "Links",
  "chart.option.alignment.center": "Midden",
  "chart.option.alignment.right": "Rechts",
  "chart.option.hideHeader.label": "Verbergen Header",
  "chart.option.hideHeader.description": "Verberg de portlet-headerbalk (titel en actieknoppen)",
  "chart.option.transparentBackground.label": "Transparante achtergrond",
  "chart.option.transparentBackground.description": "Verwijderen card background, border, en shadow voor seamless integration as section headers",
  "chart.option.autoHeight.label": "Automatisch Hoogte",
  "chart.option.autoHeight.description": "In rij en mobile layouts, grootte naar markdown content instead van fixed rij hoogte",
  "chart.option.accentBorder.label": "Accentrand",
  "chart.option.accentBorder.none": "Geen",
  "chart.option.accentBorder.left": "Links",
  "chart.option.accentBorder.top": "Boven",
  "chart.option.accentBorder.bottom": "Onderkant",
  "chart.option.accentBorder.description": "Voeg een accentkleurige rand toe aan één zijde van de inhoud",
  "chart.configText.20_percent": "20%",
  "chart.configText.40_percent": "40%",
  "chart.configText.60_percent": "60%",
  "chart.configText.80_percent": "80%",
  "chart.configText.accent_color": "Accentkleur",
  "chart.configText.activity_measure": "Activiteitsmeetwaarde",
  "chart.configText.add_2_or_more_measures_they_become_the_x_axis_categories_in_the_order_li": "Voeg 2 of meer meetwaarden toe — ze worden de X-as-categorieen in de opgegeven volgorde",
  "chart.configText.add_an_accent_colored_border_on_one_side_of_the_content": "Voeg een accentgekleurde rand toe aan een zijde van de inhoud",
  "chart.configText.all_fields_to_display_as_columns": "Alle velden om als kolommen weer te geven",
  "chart.configText.array_of_value_0_1_fraction_color_bands_shown_as_outer_arc_markers": "Array van {value (0-1 fractie), color}-banden, getoond als markeringen op de buitenste boog",
  "chart.configText.axes_categories": "Assen (Categorieen)",
  "chart.configText.bubble_colour": "Bubbelkleur",
  "chart.configText.bubble_labels": "Bubbellabels",
  "chart.configText.bubble_radius": "Bubbelstraal",
  "chart.configText.categories": "Categorieen",
  "chart.configText.choose_how_to_visualize_retention_data": "Kies hoe retentiedata wordt gevisualiseerd",
  "chart.configText.color_bubbles_by_this_field_optional": "Kleur bubbels op basis van dit veld (optioneel)",
  "chart.configText.color_for_negative_changes_decreases": "Kleur voor negatieve veranderingen (dalingen)",
  "chart.configText.color_for_positive_changes_increases": "Kleur voor positieve veranderingen (stijgingen)",
  "chart.configText.color_from_the_dashboard_palette_for_headers_bullets_and_links": "Kleur uit het dashboardpalet voor koppen, opsommingstekens en links",
  "chart.configText.color_from_the_dashboard_palette_for_the_kpi_value_text": "Kleur uit het dashboardpalet voor de KPI-waardetekst",
  "chart.configText.color_groups": "Kleurgroepen",
  "chart.configText.columns": "Kolommen",
  "chart.configText.columns_x_axis": "Kolommen (X-as)",
  "chart.configText.count_at_each_step_auto_calculated": "Aantal per stap (automatisch berekend)",
  "chart.configText.count_of_entities_following_each_path": "Aantal entiteiten dat elk pad volgt",
  "chart.configText.current_value_to_display_on_the_gauge_e_g_current_equity_margin_used": "Huidige waarde om op de meter te tonen (bijv. huidige equity, gebruikte marge)",
  "chart.configText.dimension_for_column_categories": "Dimensie voor kolomcategorieen",
  "chart.configText.dimension_for_ordering_data_typically_time": "Dimensie voor het ordenen van data (meestal tijd)",
  "chart.configText.dimension_for_pie_slices": "Dimensie voor taartsegmenten",
  "chart.configText.dimension_for_row_categories": "Dimensie voor rijcategorieen",
  "chart.configText.dimension_labels_for_each_bar_segment_e_g_symbol_transaction_type": "Dimensielabels voor elk staafsegment (bijv. symbool, transactietype)",
  "chart.configText.dimension_optional": "Dimensie (optioneel)",
  "chart.configText.dimension_to_color_points_by_category": "Dimensie om punten per categorie te kleuren",
  "chart.configText.dimension_to_color_rectangles_by_category": "Dimensie om rechthoeken per categorie te kleuren",
  "chart.configText.dimension_to_group_boxes_by_e_g_symbol_platform": "Dimensie om boxen op te groeperen (bijv. symbool, platform)",
  "chart.configText.dimension_to_split_data_into_separate_profile_lines_e_g_symbol_platform": "Dimensie om data op te splitsen in aparte profiellijnen (bijv. symbool, platform)",
  "chart.configText.dimensions_for_radar_axes": "Dimensies voor radarassen",
  "chart.configText.dimensions_for_radial_segments": "Dimensies voor radiale segmenten",
  "chart.configText.dimensions_for_treemap_rectangles": "Dimensies voor treemap-rechthoeken",
  "chart.configText.dimensions_to_create_multiple_radar_shapes": "Dimensies om meerdere radarvormen te maken",
  "chart.configText.dimensions_to_create_separate_lines": "Dimensies om afzonderlijke lijnen te maken",
  "chart.configText.dimensions_to_create_stacked_areas": "Dimensies om gestapelde gebieden te maken",
  "chart.configText.display_the_value_above_each_bar_segment": "Toon de waarde boven elk staafsegment",
  "chart.configText.display_value_at_each_data_point": "Toon de waarde bij elk datapunt",
  "chart.configText.drop_1_measure_for_auto_mode_3_for_avg_stddev_median_mode_or_5_for_min_q": "Sleep 1 meetwaarde voor automatische modus, 3 voor avg/stddev/mediaanmodus, of 5 voor min/q1/mediaan/q3/max-modus",
  "chart.configText.drop_2_4_measures_in_order_open_close_high_low_ohlc_mode_for_range_mode_": "Sleep 2-4 meetwaarden in deze volgorde: open, close, high, low (OHLC-modus). Sleep voor bereikmodus 2: high, low.",
  "chart.configText.enter_markdown_text_supports_headers_bold_text_italic_text_links_text_ur": "Voer markdowntekst in. Ondersteunt koppen (#), vet (**tekst**), cursief (*tekst*), links ([tekst](url)), lijsten (- item) en horizontale lijnen (---).",
  "chart.configText.event_dimension_that_categorizes_flow_nodes": "Eventdimensie die flowknooppunten categoriseert",
  "chart.configText.event_type": "Eventtype",
  "chart.configText.exclude_current_incomplete_period_from_aggregation_e_g_partial_week_mont": "Sluit de huidige onvolledige periode uit van aggregatie (bijv. gedeeltelijke week/maand)",
  "chart.configText.exclude_current_incomplete_period_from_delta_calculation_e_g_partial_wee": "Sluit de huidige onvolledige periode uit van deltaberekening (bijv. gedeeltelijke week/maand)",
  "chart.configText.field_to_use_for_bubble_labels_and_identification": "Veld voor bubbellabels en identificatie",
  "chart.configText.flow_count": "Flowaantal",
  "chart.configText.hide_the_statistics_footer_below_the_chart": "Verberg de statistiekfooter onder de grafiek",
  "chart.configText.hollow_center_size_0_percent_solid_pie_higher_donut_style": "Grootte van het holle midden (0% = volle taart, hoger = donutstijl)",
  "chart.configText.horizontal_alignment_of_the_markdown_content": "Horizontale uitlijning van de markdowninhoud",
  "chart.configText.horizontal_axis_position": "Horizontale aspositie",
  "chart.configText.how_to_stack_multiple_area_series": "Hoe meerdere gebiedsreeksen te stapelen",
  "chart.configText.how_to_stack_multiple_bar_series": "Hoe meerdere staafreeksen te stapelen",
  "chart.configText.markdown_content": "Markdowninhoud",
  "chart.configText.measure_for_rectangle_sizes": "Meetwaarde voor rechthoekgroottes",
  "chart.configText.measure_for_slice_sizes": "Meetwaarde voor segmentgroottes",
  "chart.configText.measure_for_y_position": "Meetwaarde voor Y-positie",
  "chart.configText.measure_or_dimension_for_x_position": "Meetwaarde of dimensie voor X-positie",
  "chart.configText.measure_that_determines_cell_color": "Meetwaarde die de celkleur bepaalt",
  "chart.configText.measure_to_display_as_kpi_number": "Meetwaarde om als KPI-getal te tonen",
  "chart.configText.measure_to_display_in_the_kpi_text_template": "Meetwaarde om in de KPI-tekstsjabloon te tonen",
  "chart.configText.measure_to_track_changes_for": "Meetwaarde om veranderingen voor te volgen",
  "chart.configText.measure_used_for_activity_intensity_color_coding": "Meetwaarde voor activiteitsintensiteit (kleurcodering)",
  "chart.configText.measures_for_area_values": "Meetwaarden voor gebiedswaarden",
  "chart.configText.measures_for_bar_heights": "Meetwaarden voor staafhoogtes",
  "chart.configText.measures_for_line_values": "Meetwaarden voor lijnwaarden",
  "chart.configText.measures_for_radar_values": "Meetwaarden voor radarwaarden",
  "chart.configText.measures_for_radial_bar_lengths": "Meetwaarden voor lengtes van radiale staven",
  "chart.configText.measures_x_axis_order": "Meetwaarden (X-asvolgorde)",
  "chart.configText.negative_change_color": "Kleur bij negatieve verandering",
  "chart.configText.none_pie": "Geen (Taart)",
  "chart.configText.number_formatting_for_cell_values_and_legend": "Getalopmaak voor celwaarden en legenda",
  "chart.configText.number_formatting_for_numeric_values": "Getalopmaak voor numerieke waarden",
  "chart.configText.number_formatting_for_size_values": "Getalopmaak voor groottewaarden",
  "chart.configText.number_formatting_for_the_displayed_value_and_axis_labels": "Getalopmaak voor de getoonde waarde en aslabels",
  "chart.configText.number_formatting_for_the_price_axis": "Getalopmaak voor de prijsas",
  "chart.configText.number_formatting_for_the_value_axis": "Getalopmaak voor de waarde-as",
  "chart.configText.number_formatting_for_the_y_axis": "Getalopmaak voor de Y-as",
  "chart.configText.number_formatting_for_x_axis_labels": "Getalopmaak voor X-aslabels",
  "chart.configText.number_formatting_for_y_axis_and_values": "Getalopmaak voor Y-as en waarden",
  "chart.configText.number_formatting_for_y_axis_labels": "Getalopmaak voor Y-aslabels",
  "chart.configText.number_of_decimal_places_to_display_for_numeric_values": "Aantal decimalen om te tonen voor numerieke waarden",
  "chart.configText.ohlc_measures_open_close_high_low": "OHLC-meetwaarden (open, close, high, low)",
  "chart.configText.opacity_of_flow_links": "Dekking van flowlinks",
  "chart.configText.overall_text_size_for_the_markdown_content": "Algemene tekstgrootte voor de markdowninhoud",
  "chart.configText.positive_change_color": "Kleur bij positieve verandering",
  "chart.configText.rows_y_axis": "Rijen (Y-as)",
  "chart.configText.series_color_groups": "Reeksen (Kleurgroepen)",
  "chart.configText.series_multiple_lines": "Reeksen (Meerdere lijnen)",
  "chart.configText.series_multiple_shapes": "Reeksen (Meerdere vormen)",
  "chart.configText.series_split_into_multiple_lines": "Reeksen (Opgesplitst in meerdere lijnen)",
  "chart.configText.series_stack_areas": "Reeksen (Gebieden stapelen)",
  "chart.configText.show_series_legend_only_visible_with_a_series_dimension": "Toon reekslegenda (alleen zichtbaar met een reeksdimensie)",
  "chart.configText.show_the_color_intensity_legend": "Toon de legenda voor kleurintensiteit",
  "chart.configText.show_the_legend_for_breakdown_segments": "Toon de legenda voor segmenten in uitsplitsing",
  "chart.configText.single_measure_whose_values_are_summed_cumulatively": "Enkele meetwaarde waarvan de waarden cumulatief worden opgeteld",
  "chart.configText.size": "Grootte",
  "chart.configText.size_of_bubbles_based_on_this_measure": "Grootte van bubbels op basis van deze meetwaarde",
  "chart.configText.size_of_the_center_hole_0_for_full_circle": "Grootte van het middengat (0 voor volledige cirkel)",
  "chart.configText.step_count": "Stapaantal",
  "chart.configText.step_name": "Stapnaam",
  "chart.configText.step_names_auto_populated_from_funnel_steps": "Stapnamen (automatisch ingevuld vanuit funnelstappen)",
  "chart.configText.target_value_to_compare_against_first_value_used_if_multiple_provided": "Doelwaarde om mee te vergelijken (eerste waarde wordt gebruikt als er meerdere zijn opgegeven)",
  "chart.configText.template_for_displaying_the_text_use_value_to_insert_the_measure_value": "Sjabloon voor het tonen van tekst. Gebruik ${value} om de meetwaarde in te voegen.",
  "chart.configText.text_template": "Tekstsjabloon",
  "chart.configText.threshold_bands": "Drempelbanden",
  "chart.configText.time_dimension": "Tijddimensie",
  "chart.configText.time_dimension_or_category_for_each_candle_e_g_date_symbol": "Tijddimensie of categorie voor elke candle (bijv. datum, symbool)",
  "chart.configText.time_dimensions_or_dimensions_for_x_axis": "Tijddimensies of dimensies voor de X-as",
  "chart.configText.time_field_that_determines_grid_structure_granularity_affects_layout": "Tijdveld dat de roosterstructuur bepaalt (granulariteit beinvloedt de layout)",
  "chart.configText.value": "Waarde",
  "chart.configText.value_color": "Waardekleur",
  "chart.configText.value_color_intensity": "Waarde (Kleurintensiteit)",
  "chart.configText.value_measure": "Waardemeetwaarde",
  "chart.configText.values": "Waarden",
  "chart.configText.vertical_axis_position": "Verticale aspositie",
  "chart.configText.visualization_style": "Visualisatiestijl",
  "chart.configText.x_axis_groups": "X-as (Groepen)",
  "chart.configText.x_axis_time_categories": "X-as (Tijd/Categorieen)",
  "chart.configText.x_axis_time_category": "X-as (Tijd / Categorie)",
  "chart.configText.y_axis": "Y-as",
  "chart.configText.y_axis_measures": "Y-as (Meetwaarden)",
  "chart.configText.y_axis_value": "Y-as (Waarde)",
  "display.loading": "Laden weergeven options...",
  "display.noOptions": "Geen weergeven options beschikbaar voor deze grafiek type.",
  "display.heading": "Weergave Opties",
  "results.loading.title": "Query uitvoeren...",
  "results.loading.subtitle": "Je query wordt uitgevoerd tegen de Cube API",
  "results.error.title": "Query Uitvoering Mislukt",
  "results.error.subtitle": "Er is een fout opgetreden bij het uitvoeren van je query. Controleer de query en probeer het opnieuw.",
  "results.waiting.title": "Query voorbereiden...",
  "results.waiting.subtitle": "Je query wordt zo uitgevoerd",
  "results.needsRefresh.title": "Ready naar Execute",
  "results.needsRefresh.subtitle": "Klik op vernieuwen om je query uit te voeren",
  "results.needsRefresh.runButton": "Uitvoeren Query",
  "results.empty.query": "Voeg metingen of uitsplitsingen toe vanuit het paneel rechts om resultaten te zien",
  "results.empty.retention": "Selecteer een cube en configureer retentie-instellingen om resultaten te zien",
  "results.empty.funnel": "Voeg funnelstappen toe om conversieanalyse te zien",
  "results.empty.flow": "Configureer flowanalyse om gebruikerspaden te zien",
  "results.empty.title": "Geen Resultaten Yet",
  "results.ai.button": "Analyse met AI",
  "results.noData.title": "Query geslaagd",
  "results.noData.subtitle": "Geen gegevens geretourneerd door de query",
  "results.chart.noData": "Geen gegevens om weer te geven",
  "results.chart.noDataHint": "Voer een query uit om grafiekvisualisatie te zien",
  "results.chart.unsupported": "Unsupported grafiek type",
  "results.refreshing": "Vernieuwen resultaten...",
  "results.header.rows": "rijen",
  "results.header.row": "rij",
  "results.header.stale": "Resultaten may be outdated",
  "results.header.failed": "Query mislukt",
  "results.header.executing": "Uitvoeren...",
  "results.header.noResults": "Geen results",
  "results.view.chart": "Grafiek",
  "results.view.merged": "Samengevoegd",
  "results.warning.largeDataset": "Groot dataset:",
  "results.warning.configChanged": "Query configuratie changed. Resultaten may be outdated.",
  "results.warning.refreshNow": "Vernieuwen Now",
  "results.share.copied": "Gekopieerd!",
  "results.share.noChart": "(geen grafiek)",
  "server.errors.dbNotConfigured": "Database-executor is niet geconfigureerd",
  "server.errors.cubeNotFound": "Cube '{cubeName}' niet gevonden",
  "server.errors.noCubesInQuery": "Geen cubes gevonden in query",
  "server.errors.dbAdapterRequired": "DatabaseExecutor moet hebben een databaseAdapter property",
  "server.errors.rlsRequiresTransactions": "rlsSetup vereist een database driver dat ondersteunt transactions (db.transaction)",
  "server.errors.queryExecutionFailed": "Query uitvoering mislukt: {message}",
  "server.errors.queryExecutionUnknown": "Query-uitvoering mislukt: onbekende fout",
  "server.errors.noCompareDateRange": "Geen compareDateRange gevonden in query",
  "server.errors.compareDateRangeInvalid": "compareDateRange vereist bij minimaal 2 periodes",
  "server.errors.funnelValidationFailed": "Funnel validatie mislukt: {errors}",
  "server.errors.flowValidationFailed": "Flow validatie mislukt: {errors}",
  "server.errors.retentionValidationFailed": "Retentie validatie mislukt: {errors}",
  "server.errors.cubeRefUnresolved": "{cubeName}.joins.{joinName}: target cube '{targetCube}' is niet registered",
  "server.errors.unresolvedCubeRefs": "Unresolved cube verwijzingen:\n{details}",
  "server.errors.calculatedMeasureValidation": "Berekend meting validatie mislukt voor cube '{cubeName}':\n{details}",
  "server.errors.queryValidationFailed": "Query validatie mislukt: {errors}",
  "server.errors.queryContainsMultipleModes": "Query bevat meerdere query modes: {modes}",
  "server.errors.primaryCubeNotFound": "Primary cube '{cubeName}' niet gevonden",
  "server.errors.noJoinPath": "Geen join pad gevonden van '{fromCube}' naar '{toCube}'",
  "server.errors.cubeNotFoundForMeasure": "Cube '{cubeName}' niet gevonden voor meting '{measure}'",
  "server.errors.cubeNotFoundForDimension": "Cube '{cubeName}' niet gevonden voor dimensie '{dimension}'",
  "server.errors.cubeNotFoundForTimeDimension": "Cube '{cubeName}' niet gevonden voor tijd dimensie '{timeDimension}'",
  "server.errors.invalidFunnelConfig": "Query is niet contain a valid funnel configuratie",
  "server.errors.invalidFlowConfig": "Query is niet contain a valid flow configuratie",
  "server.errors.invalidRetentionConfig": "Query is niet contain a valid retentie configuratie",
  "server.errors.llmInitFailed": "Mislukt naar initialize LLM provider",
  "server.validation.ai.bindingKeyRequired.flow": "flow.bindingKey is vereist",
  "server.validation.ai.bindingKeyRequired.funnel": "funnel.bindingKey is vereist",
  "server.validation.ai.bindingKeyRequired.retention": "retentie.bindingKey is vereist",
  "server.validation.ai.cubeNotFoundInFilter": "Cube '{cubeName}' niet gevonden in filter",
  "server.validation.ai.cubeNotFoundWithAvailable": "Cube '{cubeName}' niet gevonden",
  "server.validation.ai.cubeNotFoundWithSuggestion": "Cube '{cubeName}' niet gevonden",
  "server.validation.ai.dimensionNotFoundWithAvailable": "Dimensie '{dimensionName}' not gevonden on cube '{cubeName}'",
  "server.validation.ai.dimensionNotFoundWithSuggestion": "Dimensie '{dimensionName}' not gevonden on cube '{cubeName}'",
  "server.validation.ai.dimensionNotTimeType": "Dimensie '{dimension}' is not a time type (it's '{type}')",
  "server.validation.ai.emptyQuery": "Query moet hebben bij minimaal één meting van dimensie",
  "server.validation.ai.eventDimensionRequired": "flow.eventDimension is vereist",
  "server.validation.ai.filterFieldNotFound": "Filter veld '{fieldName}' niet gevonden op cube '{cubeName}'",
  "server.validation.ai.filterFieldNotFoundWithSuggestion": "Filter veld '{fieldName}' niet gevonden op cube '{cubeName}'",
  "server.validation.ai.funnelRequiresSteps": "funnel vereist bij minimaal 2 stappen",
  "server.validation.ai.funnelStepsRequired": "funnel.stappen array is vereist",
  "server.validation.ai.granularityNotSpecified": "retentie.granularity not specified",
  "server.validation.ai.invalidDimensionFormat": "Ongeldig dimensie format: '{dimension}'. Expected 'CubeName.dimensionName'",
  "server.validation.ai.invalidFilterMemberFormat": "Ongeldig filter member format: '{member}'",
  "server.validation.ai.invalidMeasureFormat": "Ongeldig meting format: '{measure}'. Expected 'CubeName.measureName'",
  "server.validation.ai.measureNotFoundWithAvailable": "Meting '{measureName}' not gevonden on cube '{cubeName}'",
  "server.validation.ai.measureNotFoundWithSuggestion": "Meting '{measureName}' not gevonden on cube '{cubeName}'",
  "server.validation.ai.performanceManyDimensions": "Query heeft {count} dimensies, welke kan produce veel rijen",
  "server.validation.ai.performanceManyMeasures": "Query heeft {count} metingen, welke kan impact prestatie",
  "server.validation.ai.periodsNotSpecified": "retentie.periods not specified",
  "server.validation.ai.retentionTimeDimensionRequired": "retentie.timeDimension is vereist",
  "server.validation.ai.stepMissingName": "Stap {step} is ontbrekend a name",
  "server.validation.ai.stepsBothMissing": "Neither stepsBefore nor stepsAfter opgegeven",
  "server.validation.ai.suggestAddDimensionFilters": "Overweeg adding filters van reducing dimensies",
  "server.validation.ai.suggestAddStepNames": "Voeg descriptive names naar funnel stappen",
  "server.validation.ai.suggestSetSteps": "Set stepsBefore en/van stepsAfter naar zien gebeurtenis sequences",
  "server.validation.ai.suggestSpecifyGranularity": "Specify granularity: \"day\", \"week\", van \"maand\"",
  "server.validation.ai.suggestSpecifyPeriods": "Specify nummer van periodes naar analyze",
  "server.validation.ai.suggestSplitQueries": "Overweeg splitting naar meerdere queries",
  "server.validation.ai.suggestUseTimeDimension": "Gebruik a dimensie met type \"time\" voor timeDimensions",
  "server.validation.ai.timeDimensionRequired.flow": "flow.timeDimension is vereist",
  "server.validation.ai.timeDimensionRequired.funnel": "funnel.timeDimension is vereist",
  "server.validation.chart.barNeedsDimension": "Staafgrafieken hebben een xAxis-dimensie nodig voor categorielabels. Voeg een dimensie toe aan de query of gebruik in plaats daarvan het grafiektype \"table\".",
  "server.validation.chart.barXAxisRequired": "chartConfig.xAxis is vereist voor staaf grafieken. Put een dimensie in xAxis so bars hebben categorie labels.",
  "server.validation.chart.dropZoneRequired": "chartConfig.{key} is vereist voor {chartType} grafiek ({label}). Accepts: {acceptDesc}.",
  "server.validation.chart.seriesDuplicatesXAxis": "chartConfig.series mag niet hetzelfde veld bevatten als xAxis (gevonden: {duplicates}). Het series-veld is alleen bedoeld om te splitsen in gegroepeerde/gestapelde subseries met een ANDERE dimensie. Verwijder het duplicaat uit series.",
  "server.validation.flow.bindingKeyCubeNotFound": "Koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.flow.bindingKeyDimNotFound": "Koppeling sleutel dimensie niet gevonden: {dimName} in cube {cubeName}",
  "server.validation.flow.bindingKeyMappingCubeNotFound": "Koppeling sleutel mapping cube niet gevonden: {cubeName}",
  "server.validation.flow.eventDimCubeNotFound": "Gebeurtenis dimensie cube not gevonden: {cubeName}",
  "server.validation.flow.eventDimNotFound": "Gebeurtenis dimensie not gevonden: {dimName} in cube {cubeName}",
  "server.validation.flow.eventDimRequired": "Gebeurtenis dimensie is vereist voor flow analyse",
  "server.validation.flow.highStepDepthWarning": "Hoog stap depth (4-5) kan impact query prestatie op groot datasets",
  "server.validation.flow.invalidBindingKeyFormat": "Ongeldig binding key format: {bindingKey}. Expected 'CubeName.dimensionName'",
  "server.validation.flow.invalidEventDimFormat": "Ongeldig gebeurtenis dimensie format: {eventDimension}. Expected 'CubeName.dimensionName'",
  "server.validation.flow.invalidJoinStrategy": "Ongeldig joinStrategy: {joinStrategy}",
  "server.validation.flow.invalidTimeDimFormat": "Ongeldig time dimensie format: {timeDimension}. Expected 'CubeName.dimensionName'",
  "server.validation.flow.lateralNotSupported": "Lateral joins zijn niet supported op deze database",
  "server.validation.flow.lateralNotSupportedExec": "Lateral joins met CTE verwijzingen zijn niet supported op deze database",
  "server.validation.flow.sqliteNotSupported": "Flow queries zijn niet supported on SQLite. Gebruik PostgreSQL of MySQL voor flow analyse.",
  "server.validation.flow.startingStepFilterRequired": "Startende stap moet hebben bij minimaal één filter",
  "server.validation.flow.startingStepNameMissing": "Startende stap heeft geen naam - met standaard",
  "server.validation.flow.startingStepRequired": "Startende stap is vereist voor flow analyse",
  "server.validation.flow.stepsBeforeRange": "stepsBefore moet zijn tussen 0 en 5, got: {value}",
  "server.validation.flow.stepsAfterRange": "stepsAfter moet zijn tussen 0 en 5, got: {value}",
  "server.validation.flow.timeDimCubeNotFound": "Tijd dimensie cube not gevonden: {cubeName}",
  "server.validation.flow.timeDimNotFound": "Tijd dimensie not gevonden: {dimName} in cube {cubeName}",
  "server.validation.funnel.bindingKeyCubeNotFound": "Koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.funnel.bindingKeyDimNotFound": "Koppeling sleutel dimensie niet gevonden: {dimName} in cube {cubeName}",
  "server.validation.funnel.bindingKeyMappingCubeNotFound": "Koppeling sleutel mapping cube niet gevonden: {cubeName}",
  "server.validation.funnel.invalidBindingKeyFormat": "Ongeldig binding key format: {bindingKey}. Expected 'CubeName.dimensionName'",
  "server.validation.funnel.invalidTimeDimFormat": "Ongeldig time dimensie format: {timeDimension}. Expected 'CubeName.dimensionName'",
  "server.validation.funnel.minSteps": "Funnel moet hebben bij minimaal 2 stappen",
  "server.validation.funnel.stepCubeNotFound": "Stap {step} cube not gevonden: {cube}",
  "server.validation.funnel.stepFilterCubeNotFound": "Stap {step} filter cube not gevonden: {cubeName}",
  "server.validation.funnel.stepFilterIsMeasure": "Stap {step} filter '{member}' is a meting. Funnel stap filters only support dimensies, not metingen.",
  "server.validation.funnel.stepFilterMemberNotFound": "Stap {step} filter member not gevonden: {field} in cube {cubeName}",
  "server.validation.funnel.stepFilterNoJoinPath": "Stap {step} filter '{member}' requires a join van '{stepCube}' but no join pad was gevonden. Define a join relationship tussen these cubes.",
  "server.validation.funnel.stepMustHaveName": "Stap {step} moet have a name",
  "server.validation.funnel.stepTimeToConvertFormat": "Stap {step} timeToConvert moet be ISO 8601 duration format: {value}",
  "server.validation.funnel.timeDimCubeNotFound": "Tijd dimensie cube not gevonden: {cubeName}",
  "server.validation.funnel.timeDimNotFound": "Tijd dimensie not gevonden: {dimName} in cube {cubeName}",
  "server.validation.retention.bindingKeyCubeNotFound": "Koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.retention.bindingKeyDimNotFound": "Koppeling sleutel dimensie niet gevonden: {dimName} in cube {cubeName}",
  "server.validation.retention.bindingKeyMappingCubeNotFound": "Koppeling sleutel mapping cube niet gevonden: {cubeName}",
  "server.validation.retention.breakdownDimCubeNotFound": "Opsplitsing dimensie cube niet gevonden: {cubeName}",
  "server.validation.retention.breakdownDimNotFound": "Opsplitsing dimensie niet gevonden: {dimName} in cube {cubeName}",
  "server.validation.retention.cubeNotFound": "Cube niet gevonden: {cubeName}",
  "server.validation.retention.dateRangeEndRequired": "Datum range end is vereist",
  "server.validation.retention.dateRangeInvalidEnd": "Ongeldig date range end format",
  "server.validation.retention.dateRangeInvalidStart": "Ongeldig date range start format",
  "server.validation.retention.dateRangeRequired": "Datum range is vereist",
  "server.validation.retention.dateRangeStartBeforeEnd": "Datum range start moet be voor of equal naar end",
  "server.validation.retention.dateRangeStartRequired": "Datum range start is vereist",
  "server.validation.retention.engineNotSupported": "Retentie queries worden niet ondersteund op {engine}. Gebruik PostgreSQL of DuckDB voor retentie analyse.",
  "server.validation.retention.invalidBindingKeyFormat": "Ongeldig binding key format: {bindingKey}. Expected 'CubeName.dimensionName'",
  "server.validation.retention.invalidBreakdownDimFormat": "Ongeldig breakdown dimensie format: {dimension}. Expected 'CubeName.dimensionName'",
  "server.validation.retention.invalidGranularity": "Ongeldig granularity: {granularity}",
  "server.validation.retention.invalidRetentionType": "Ongeldig retentie type: {retentionType}",
  "server.validation.retention.invalidTimeDimFormat": "Ongeldig time dimensie format: {timeDimension}",
  "server.validation.retention.noBindingKeyMapping": "Geen binding key mapping gevonden voor cube: {cubeName}",
  "server.validation.retention.periodsMax": "Periodes kan niet exceed 52 (prestatie limiet)",
  "server.validation.retention.periodsMin": "Periodes moet zijn bij minimaal 1",
  "server.validation.retention.timeDimNotFound": "Tijd dimensie not gevonden: {dimName}",
  "server.validation.calculatedMeasure.mustHaveCalculatedSql": "Berekend meting '{cubeName}.{fieldName}' moet hebben calculatedSql property",
  "server.validation.calculatedMeasure.invalidSyntax": "Ongeldig calculatedSql syntax in '{cubeName}.{fieldName}': {errors}",
  "server.validation.calculatedMeasure.circularDependency": "Circular dependency detected in berekend metingen: {cycle}",
  "server.validation.query.multipleQueryModes": "Query bevat meerdere query modes: {modes}",
  "server.validation.query.funnelBindingKeyCubeNotFound": "Funnel koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.query.flowBindingKeyCubeNotFound": "Flow koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.query.retentionCubeNotFound": "Retentie cube niet gevonden: {cubeName}",
  "server.validation.query.retentionBindingKeyCubeNotFound": "Retentie koppeling sleutel cube niet gevonden: {cubeName}",
  "server.validation.query.retentionBreakdownCubeNotFound": "Retentie opsplitsing cube niet gevonden: {cubeName}",
  "server.validation.query.invalidMeasureFormat": "Ongeldig meting format: {measure}. Expected format: 'CubeName.fieldName'",
  "server.validation.query.cubeNotFoundForMeasure": "Cube '{cubeName}' niet gevonden (referenced in meting '{measure}')",
  "server.validation.query.measureNotFound": "Meting '{fieldName}' not gevonden on cube '{cubeName}'{hint}",
  "server.validation.query.invalidDimensionFormat": "Ongeldig dimensie format: {dimension}. Expected format: 'CubeName.fieldName'",
  "server.validation.query.cubeNotFoundForDimension": "Cube '{cubeName}' niet gevonden (referenced in dimensie '{dimension}')",
  "server.validation.query.dimensionNotFound": "Dimensie '{fieldName}' not gevonden on cube '{cubeName}'{hint}",
  "server.validation.query.invalidTimeDimensionFormat": "Ongeldig timeDimension format: {dimension}. Expected format: 'CubeName.fieldName'",
  "server.validation.query.cubeNotFoundForTimeDimension": "Cube '{cubeName}' niet gevonden (referenced in timeDimension '{dimension}')",
  "server.validation.query.timeDimensionNotFound": "TimeDimension '{fieldName}' niet gevonden op cube '{cubeName}' (moet zijn een dimensie met tijd type)",
  "server.validation.query.mustReferenceAtLeastOneCube": "Query moet reference bij minimaal één cube through metingen, dimensies, van filters",
  "server.validation.query.ungroupedRequiresDimension": "Ongegroepeerd queries require bij minimaal één dimensie van tijd dimensie",
  "server.validation.query.ungroupedIncompatibleFunnel": "Ungrouped queries are incompatible met funnel analyse",
  "server.validation.query.ungroupedIncompatibleFlow": "Ungrouped queries are incompatible met flow analyse",
  "server.validation.query.ungroupedIncompatibleRetention": "Ungrouped queries are incompatible met retentie analyse",
  "server.validation.query.ungroupedIncompatibleCompareDateRange": "Ongegroepeerd queries zijn incompatible met compareDateRange",
  "server.validation.query.ungroupedIncompatibleFillMissingDates": "Ongroepeerde queries zijn niet compatibel met fillMissingDates",
  "server.validation.query.filterMustHaveMember": "Filter moet hebben een lid veld",
  "server.validation.query.invalidFilterMemberFormat": "Ongeldig filter member format: {member}. Expected format: 'CubeName.fieldName'",
  "server.validation.query.cubeNotFoundForFilter": "Cube '{cubeName}' niet gevonden (referenced in filter '{member}')",
  "server.validation.query.filterFieldNotFound": "Filter veld '{fieldName}' niet gevonden op cube '{cubeName}' (moet zijn een dimensie van meting){hint}",
  "server.errors.funnel.cubeNotFoundForStep": "Cube niet gevonden voor stap: {cube}",
  "server.errors.funnel.cubeNotFoundForBindingKey": "Cube niet gevonden voor koppeling sleutel: {bindingKey}",
  "server.errors.funnel.cannotResolveCubeForStep": "Kan niet resolve cube voor stap - meerdere-cube funnel vereist cube specification in each stap",
  "server.errors.funnel.bindingKeyDimNotFound": "Koppeling sleutel dimensie niet gevonden: {bindingKey}",
  "server.errors.funnel.noBindingKeyMapping": "Geen binding key mapping gevonden voor cube: {cubeName}",
  "server.errors.funnel.bindingKeyMappingDimNotFound": "Koppeling sleutel dimensie niet gevonden: {dimension}",
  "server.errors.funnel.timeDimNotFound": "Tijd dimensie not gevonden: {timeDimension}",
  "server.errors.funnel.noTimeDimMapping": "Geen time dimensie mapping gevonden voor cube: {cubeName}",
  "server.errors.funnel.timeDimMappingNotFound": "Tijd dimensie not gevonden: {dimension}",
  "server.errors.flow.cannotResolveCube": "Kan niet resolve cube voor flow query",
  "server.errors.flow.cubeNotFound": "Cube niet gevonden: {cubeName}",
  "server.errors.flow.bindingKeyDimNotFound": "Koppeling sleutel dimensie niet gevonden: {bindingKey}",
  "server.errors.flow.noBindingKeyMapping": "Geen binding key mapping gevonden voor cube: {cubeName}",
  "server.errors.flow.bindingKeyMappingDimNotFound": "Koppeling sleutel dimensie niet gevonden: {dimension}",
  "server.errors.flow.timeDimNotFound": "Tijd dimensie not gevonden: {timeDimension}",
  "server.errors.flow.noTimeDimMapping": "Geen time dimensie mapping gevonden voor cube: {cubeName}",
  "server.errors.flow.timeDimMappingNotFound": "Tijd dimensie not gevonden: {dimension}",
  "server.errors.flow.eventDimNotFound": "Gebeurtenis dimensie not gevonden: {eventDimension}",
  "server.validation.template.emptyReference": "Leeg lid reference {} gevonden in template",
  "server.validation.template.invalidMemberReference": "Ongeldig member reference {ref}: moet start met letter of underscore, en contain only letters, numbers, underscores, en dots",
  "server.validation.template.multipleDots": "Ongeldig member reference {ref}: only one dot allowed (Cube.meting format)",
  "server.validation.template.nestedBraces": "Nested braces zijn niet allowed in lid verwijzingen",
  "server.validation.template.substituteTargetCubeNotFound": "Kan niet substitute {ref}: cube '{cubeName}' niet gevonden",
  "server.validation.template.substituteMeasureNotResolved": "Kan niet substitute {ref}: meting '{measureName}' niet resolved yet. Ensure metingen zijn resolved in dependency order.",
  "server.validation.template.unmatchedClosingBrace": "Unmatched closing brace bij position {position}",
  "server.validation.template.unmatchedOpeningBrace": "Ongepaarde openingsaccolade in sjabloon",
  "notebook.aiAssistant": "AI-assistent",
  "notebook.saveAsDashboard": "Opslaan as Dashboard",
  "notebook.saveAsDashboardTitle": "Opslaan notebook as a dashboard",
  "notebook.clearTitle": "Wissen notebook en chat",
  "notebook.feedbackThanks": "Thanks voor je feedback!",
  "notebook.feedbackQuestion": "Was deze helpful?",
  "notebook.feedbackYes": "Ja",
  "notebook.feedbackNo": "Nee",
  "notebook.thinking": "Denken...",
  "notebook.emptyState.title": "Gegevens Analyse Assistant",
  "notebook.emptyState.description": "Ask me about je gegevens en I'll create visualisaties en insights.",
  "notebook.emptyState.example1": "\"Toon me employee productivity trends\"",
  "notebook.emptyState.example2": "\"What zijn de boven departments op headcount?\"",
  "notebook.emptyState.example3": "\"Vergelijk omzet per productcategorie\"",
  "notebook.saveAsDashboardPrompt": "Sla het huidige notebook op als dashboard met een professionele lay-out, sectiekoppen en passende filters.",
  "notebook.chatInput.placeholder": "Ask about je gegevens...",
  "notebook.chatInput.stop": "Stoppen",
  "notebook.chatInput.continue": "Doorgaan",
  "notebook.chatInput.send": "Verzenden",
  "notebook.canvas.emptyTitle": "Je notebook is leeg",
  "notebook.canvas.emptyDescription": "Stel de AI-assistent een vraag over je gegevens. Grafieken en inzichten verschijnen hier terwijl de assistent je gegevens analyseert.",
  "notebook.canvas.editVisualization": "Bewerken Visualization",
  "notebook.canvas.update": "Bijwerken",
  "notebook.collapsed.noBlocks": "Geen blocks",
  "notebook.collapsed.expandNotebook": "Notitieblok uitklappen",
  "notebook.collapsed.expandChat": "AI-chat uitklappen",
  "notebook.collapsed.aiChat": "AI-chat",
  "notebook.collapsed.markdown": "Markdown",
  "schema.loading": "Laden cube schema...",
  "schema.error": "Mislukt naar load cube schema",
  "schema.noCubes": "Geen cubes gevonden",
  "schema.noCubesHint": "Register some kubussen naar zien de relationship diagram",
  "schema.computingLayout": "Layout berekenen...",
  "schema.searchPlaceholder": "Zoeken cubes en velden...",
  "schema.autoLayout": "Automatisch Layout",
  "schema.missingDeps.title": "Schema Visualization vereist additional packages",
  "schema.missingDeps.description": "Install de vereist dependencies naar enable de interactive schema diagram:",
  "schema.loadingVisualization": "Laden schema visualisatie...",
  "schema.measures": "Metingen ({count})",
  "schema.timeDimensions": "Tijd Dimensies ({count})",
  "schema.dimensions": "Dimensies ({count})",
  "schema.cubeInfo": "Cube-info",
  "dataBrowser.selectCube": "Selecteer a cube",
  "dataBrowser.selectCubeHint": "Kies een cube uit de zijbalk om de gegevens te bekijken",
  "dataBrowser.loadingData": "Laden gegevens...",
  "dataBrowser.noData": "Geen gegevens",
  "dataBrowser.noRows": "Geen rijen geretourneerd voor deze query",
  "dataBrowser.toolbar.filters": "Filters",
  "dataBrowser.toolbar.columns": "Kolommen",
  "dataBrowser.toolbar.rows": "{count} rijen",
  "dataBrowser.sidebar.cubes": "Kubussen",
  "dataBrowser.sidebar.searchPlaceholder": "Zoeken...",
  "dataBrowser.sidebar.noCubes": "Geen cubes gevonden",
  "queryAnalysis.summary": "Query Samenvatting",
  "queryAnalysis.summary.type": "Type",
  "queryAnalysis.summary.cubes": "Kubussen",
  "queryAnalysis.summary.joins": "Joins",
  "queryAnalysis.summary.ctes": "CTE's",
  "queryAnalysis.summary.strategy": "Strategie",
  "queryAnalysis.primaryCube": "Primary Cube (VAN tabel)",
  "queryAnalysis.primaryCube.showCandidates": "Toon candidates ({count})",
  "queryAnalysis.primaryCube.reachable": "bereikbaar",
  "queryAnalysis.primaryCube.cannotReachAll": "kan niet reach alle",
  "queryAnalysis.joinPaths": "Join Paden",
  "queryAnalysis.joinPaths.steps": "{count} stap",
  "queryAnalysis.joinPaths.stepsPlural": "{count} stappen",
  "queryAnalysis.joinPaths.noPath": "Geen pad",
  "queryAnalysis.joinPaths.selection": "Selectie:",
  "queryAnalysis.joinPaths.pathCandidates": "Pad scoring candidates ({count})",
  "queryAnalysis.joinPaths.visitedCubes": "Kubussen visited during search ({count})",
  "queryAnalysis.preAggregations": "Pre-aggregatie-CTE's",
  "queryAnalysis.preAggregations.measures": "Metingen:",
  "queryAnalysis.preAggregations.joinKeys": "Join-sleutels:",
  "queryAnalysis.warnings": "Waarschuwingen",
  "queryAnalysis.cubesInvolved": "Kubussen involved:",
  "common.actions.copied": "Gekopieerd",
  "common.actions.copyToClipboard": "Kopiëren naar clipboard",
  "chart.availability.requiresMeasure": "Vereist ten minste 1 meting",
  "chart.availability.requiresTwoMeasures": "Vereist ten minste 2 metingen",
  "chart.availability.requiresDimension": "Vereist ten minste 1 dimensie",
  "chart.availability.requiresTwoDimensions": "Vereist ten minste 2 dimensies",
  "chart.availability.requiresTimeDimension": "Vereist een tijdsdimensie",
  "chart.availability.scatter": "Vereist 2 metingen, of 1 meting plus 1 dimensie",
  "chart.availability.bubble": "Vereist ten minste 2 metingen en 1 dimensie",

  "chart.runtime.noData": "Geen gegevens beschikbaar",
  "chart.runtime.noDataHint.bar": "Geen datapunten om weer te geven in staafgrafiek",
  "chart.runtime.noDataHint.line": "Geen datapunten om weer te geven in lijngrafiek",
  "chart.runtime.noDataHint.area": "Geen datapunten om weer te geven in vlakgrafiek",
  "chart.runtime.noDataHint.pie": "Geen datapunten om weer te geven in cirkeldiagram",
  "chart.runtime.noDataHint.scatter": "Geen datapunten om weer te geven in spreidingsdiagram",
  "chart.runtime.noDataHint.radar": "Geen datapunten om weer te geven in radardiagram",
  "chart.runtime.noDataHint.radialBar": "Geen datapunten om weer te geven in radial staafgrafiek",
  "chart.runtime.noDataHint.treemap": "Geen datapunten om weer te geven in boomkaart",
  "chart.runtime.noDataHint.bubble": "Geen datapunten om weer te geven in bellendiagram",
  "chart.runtime.noDataHint.boxPlot": "Geen datapunten om weer te geven in boxplot",
  "chart.runtime.noDataHint.waterfall": "Geen datapunten om weer te geven in watervalgrafiek",
  "chart.runtime.noDataHint.candlestick": "Geen datapunten om weer te geven in candlestickgrafiek",
  "chart.runtime.noDataHint.gauge": "Geen datapunten om weer te geven in meterdiagram",
  "chart.runtime.noDataHint.measureProfile": "Geen datapunten om weer te geven in meetprofielgrafiek",
  "chart.runtime.noDataHint.activityGrid": "Geen datapunten om weer te geven in activiteitenraster",
  "chart.runtime.noDataHint.heatmap": "Voer een query uit om de heatmap-visualisatie te zien",
  "chart.runtime.noDataHint.table": "Geen gegevens naar weergeven in tabel",
  "chart.runtime.noDataHint.kpi": "Geen gegevens points naar weergeven",
  "chart.runtime.noDataHint.funnel": "Configureer een funnel met minimaal 2 stappen en een koppelingssleutel",
  "chart.runtime.noDataHint.flow": "Configureer een flowanalyse met een startstap en eventdimensie",
  "chart.runtime.noDataHint.retention": "Configureer retentieanalyse om resultaten te zien",
  "chart.runtime.noValidData": "Geen geldige gegevens",
  "chart.runtime.noValidDataHint.bar": "Geen geldige datapunten voor staafgrafiek na transformatie",
  "chart.runtime.noValidDataHint.line": "Geen geldige datapunten voor lijngrafiek na transformatie",
  "chart.runtime.noValidDataHint.area": "Geen geldige datapunten voor vlakgrafiek na transformatie",
  "chart.runtime.noValidDataHint.scatter": "Geen geldige datapunten voor spreidingsdiagram na transformatie",
  "chart.runtime.noValidDataHint.radar": "Geen geldige datapunten voor radardiagram na transformatie",
  "chart.runtime.noValidDataHint.radialBar": "Geen geldige datapunten voor radial staafgrafiek na transformatie",
  "chart.runtime.noValidDataHint.treemap": "Geen geldige datapunten voor boomkaart na transformatie",
  "chart.runtime.noValidDataHint.pie": "Geen datapunten om weer te geven in cirkeldiagram",
  "chart.runtime.noValidDataHint.pieFiltered": "Uitgefilterd {count} gegevens punten (zero van ongeldig waarden)",
  "chart.runtime.noValidDataHint.boxPlot": "Kon boxplotstatistieken niet berekenen uit de opgegeven gegevens",
  "chart.runtime.noValidDataHint.gauge": "Gauge-waarde is geen geldig getal",
  "chart.runtime.noValidDataHint.kpiText": "Alle waarden are null of ongeldig",
  "chart.runtime.configError": "Configuratiefout",
  "chart.runtime.configErrorHint.axisInvalid": "Ongeldige of ontbrekende grafiek-asconfiguratie",
  "chart.runtime.configErrorHint.axisFields": "Vereiste velden voor X-as of Y-as ontbreken",
  "chart.runtime.configErrorHint.pieAxis": "chartConfig.x/y of chartConfig.xAxis/yAxis is vereist voor cirkeldiagram",
  "chart.runtime.configErrorHint.radarNumeric": "Geen numerieke velden gevonden voor radardiagramwaarden",
  "chart.runtime.configErrorHint.radialBarNumeric": "Geen numeriek veld gevonden voor radial-bar-grafiekwaarden",
  "chart.runtime.configErrorHint.treemapNumeric": "Geen numeriek veld gevonden voor treemapgrootte",
  "chart.runtime.configErrorHint.noMeasure": "Geen metingveld geconfigureerd",
  "chart.runtime.configErrorHint.noMeasures": "Geen metingvelden geconfigureerd",
  "chart.runtime.configErrorHint.bubbleRequired": "Bellendiagram vereist xAxis-, yAxis-, reeksen- en sizeField-dimensies",
  "chart.runtime.configErrorHint.bubbleOptional": "Optioneel: colorField voor bubble-kleuring",
  "chart.runtime.configErrorHint.activityGridRequired": "Activiteitsraster vereist een tijdsdimensie en een meting",
  "chart.runtime.chartError": "{chartType} Fout",
  "chart.runtime.unknownError": "Onbekende renderfout",
  "chart.runtime.checkConfig": "Controleer de gegevens en configuratie",
  "chart.runtime.unableToRender": "Kan retentiegegevens niet renderen",
  "chart.runtime.dataFormatIncorrect": "Gegevensindeling kan onjuist zijn",
  "chart.runtime.measuringDimensions": "Grafiekafmetingen worden gemeten...",
  "chart.runtime.unableToDisplay": "Kan grafiek niet weergeven",
  "chart.runtime.responsiveContainerError": "Maken van responsieve container mislukt",
  "chart.runtime.noDataToDisplay": "Geen gegevens om weer te geven",
  "chart.runtime.table.invalidStructure": "Gegevens structure is ongeldig",
  "chart.runtime.heatmapNoResults": "De query retourneerde geen resultaten voor de heatmap",
  "chart.runtime.heatmapConfigRequired": "Configuratie vereist",
  "chart.runtime.heatmapXRequired": "X-asdimensie vereist.",
  "chart.runtime.heatmapYRequired": "Y-asdimensie vereist.",
  "chart.runtime.heatmapValueRequired": "Waarde-meting vereist.",
  "chart.runtime.heatmapTruncated": "Gegevens ingekort tot {maxRows}x{maxCols} cellen (origineel: {originalRows}x{originalCols}). Voeg filters toe om dimensies te verkleinen.",
  "chart.runtime.activityGridGranularityTooHigh": "Granulariteit te hoog",
  "chart.runtime.activityGridGranularityHint": "Activiteitsrasters werken het best met uur-, dag-, week-, maand- of kwartaalgranulariteit",
  "chart.runtime.activityGridGranularityAction": "Kies een lagere granulariteit voor je tijdsdimensie",
  "chart.runtime.activityGridConfigRequired": "Configuratie vereist",
  "chart.runtime.retention.cohort": "Cohort",
  "chart.runtime.retention.segment": "Segment",
  "chart.runtime.retention.users": "Gebruikers",
  "chart.runtime.retention.cohortSize": "Cohortgrootte: {count}",
  "chart.runtime.retention.retained": "Behouden: {count}",
  "chart.runtime.retention.rate": "Percentage: {rate}",
  "chart.runtime.retention.retentionPercent": "Retentie %",
  "chart.runtime.retention.periodLabel": "{cohort} - Periode {period}",
  "chart.runtime.retention.noData": "Geen gegevens",
  "chart.runtime.retention.total": "Totaal",
  "chart.runtime.retention.retention": "Retentie",
  "chart.runtime.funnel.noData": "Geen funnelgegevens",
  "chart.runtime.funnel.steps": "stappen",
  "chart.runtime.funnel.overall": "Totaal:",
  "chart.runtime.funnel.completed": "{completed} / {total} voltooid",
  "chart.runtime.flow.noData": "Geen flowgegevens",
  "chart.runtime.flow.events": "gebeurtenissen",
  "chart.runtime.flow.eventsAfter": "gebeurtenissen (na)",
  "chart.runtime.flow.paths": "Paden:",
  "chart.runtime.flow.startingEntities": "startende entiteiten",
  "chart.runtime.flow.entities": "entiteiten",
  "chart.runtime.kpiDelta.insufficientData": "Onvoldoende gegevens",
  "chart.runtime.kpiDelta.requiresTwoPoints": "Delta calculation vereist bij minimaal 2 gegevens punten",
  "chart.runtime.kpiDelta.currentPoints": "Huidige gegevens points: {count}",
  "chart.runtime.kpiDelta.noVariance": "Geen variance gegevens",
  "chart.runtime.kpiNumber.noData": "Geen gegevens",
  "chart.runtime.markdown.noContent": "Geen inhoud",
  "chart.runtime.markdown.addContent": "Voeg markdown-inhoud toe in de grafiekconfiguratie",
  "chart.runtime.axisFormat.label": "Label",
  "chart.runtime.axisFormat.autoLabel": "Automatisch-gegenereerd label",
  "chart.runtime.axisFormat.unit": "Eenheid",
  "chart.runtime.axisFormat.custom": "Aangepast",
  "chart.runtime.axisFormat.prefix": "Voorvoegsel",
  "chart.runtime.axisFormat.prefixExample": "bijv., $",
  "chart.runtime.axisFormat.suffix": "Achtervoegsel",
  "chart.runtime.axisFormat.suffixExample": "bijv., eenheden",
  "chart.runtime.axisFormat.abbreviation": "Afkorting",
  "chart.runtime.axisFormat.yes": "Ja",
  "chart.runtime.axisFormat.no": "Nee",
  "chart.runtime.axisFormat.decimals": "Decimalen",
  "chart.runtime.axisFormat.preview": "Voorbeeld",
  "chart.runtime.axisFormat.leftYAxis": "Left Y-As",
  "chart.runtime.axisFormat.rightYAxis": "Right Y-As",
  "chart.runtime.axisFormat.xAxis": "X-As",
  "chart.runtime.missingDep.title": "Ontbrekende afhankelijkheid",
  "chart.runtime.missingDep.description": "De {chartType} grafiek vereist de {packageName} package.",
  "chart.runtime.missingDep.restartHint": "Start na installatie je ontwikkelserver opnieuw.",
  "chart.runtime.unknownChartType": "Onbekend grafiektype",
  "chart.runtime.unknownChartTypeHint": "\"{chartType}\" is niet registered",
  "chart.runtime.boxPlot.truncated": "Gegevens ingekort tot {max} groepen (origineel: {total})",
  "chart.runtime.candlestick.truncated": "Toont de eerste {max} candles (totaal: {total})",
  "chart.runtime.bar.hiddenPoints": "{count} gegevens punt(en) met geen waarden hidden",
  "chart.runtime.waterfall.increase": "Toename",
  "chart.runtime.waterfall.decrease": "Afname",
  "chart.runtime.waterfall.total": "Totaal",
  "chart.runtime.tooltip.noData": "Geen gegevens",
  "chart.runtime.tooltip.targetValue": "Doelwaarde",
  "results.toolbar.refreshing": "Vernieuwen",
  "results.toolbar.refresh": "Vernieuwen",
  "results.toolbar.refreshTitle": "Vernieuwen gegevens (Shift+klik naar bypass cache)",
  "results.toolbar.refreshingTitle": "Vernieuwen...",
  "results.toolbar.cacheBustTitle": "Klik naar vernieuw en bypass cache",
  "results.toolbar.clear": "Wissen",
  "results.toolbar.clearFunnel": "Wissen funnel",
  "results.toolbar.clearQuery": "Wissen alle query gegevens",
  "results.toolbar.aiClose": "Sluiten AI assistant",
  "results.toolbar.aiOpen": "Analyse met AI",
  "results.toolbar.shareTitle": "Share deze analyse",
  "results.toolbar.shareCopied": "Link gekopieerd!",
  "results.toolbar.schemaHide": "Verbergen schema diagram",
  "results.toolbar.schemaShow": "Toon schema diagram",
  "results.toolbar.debugHide": "Verbergen debug info",
  "results.toolbar.debugShow": "Toon debug info",
  "results.toolbar.chartView": "Grafiek view",
  "results.toolbar.chartDisabled": "Voeg metingen naar enable grafiek view",
  "results.toolbar.tableView": "Tabel view",
  "results.toolbar.mergedTableView": "Merged tabel view",
  "results.view.table": "Tabel",
  "results.warning.filterHint": "Overweeg adding filters naar improve prestatie.",
  "results.debug.query": "Query:",
  "results.debug.queryAnalysis": "Query Analyse",
  "results.debug.copyMarkdownTitle": "Kopieer query, analyse, en SQL as markdown",
  "results.debug.copyAsMarkdown": "Kopiëren as Markdown",
  "results.debug.analysisError": "Analyse unavailable due naar fout",
  "results.debug.analysisEmpty": "Voeg metingen toe om analyse te zien",
  "results.debug.cubeQuery": "Cube-query",
  "results.debug.cubeQueryExecuted": "Executed Query (met funnel filters)",
  "results.debug.funnelFilterHint": "Deze query includes an IN filter met koppeling sleutel waarden van de previous stap",
  "results.debug.noQuery": "Geen query",
  "results.debug.serverResponse": "Serverantwoord",
  "results.debug.noResults": "Geen results yet",
  "results.debug.chartConfig": "Grafiek Configuratie",
  "results.debug.displayConfig": "Weergave Configuratie",
  "results.debug.generatedSql": "Gegenereerd SQL",
  "results.debug.loadingSql": "Laden SQL...",
  "results.debug.executionError": "Execution Fout",
  "results.confirm.clearFunnel": "Wissen Funnel",
  "results.confirm.clearQuery": "Wissen Query",
  "results.confirm.clearFunnelMessage": "Zijn je sure je want naar clear deze funnel? Deze action kan niet be undone.",
  "results.confirm.clearQueryMessage": "Zijn je sure je want naar clear deze query? Deze action kan niet be undone.",
  "results.table.noData": "Geen gegevens om weer te geven",
  "results.table.noDataHint": "Voer een query uit om tabelgegevens te zien",
  "results.flow.noData": "Geen flow gegevens naar weergeven",
  "results.flow.noDataHint": "Configureer flowanalyse om resultaten te zien",
  "results.flow.nodes": "Knooppunten ({count})",
  "results.flow.transitions": "Overgangen ({count})",
  "results.flow.layer": "Laag",
  "results.flow.name": "Naam",
  "results.flow.count": "Aantal",
  "results.flow.from": "Van",
  "results.flow.to": "Naar",
  "results.debug.funnel.label": "Trechter-query",
  "results.debug.funnel.steps": "{count} stappen",
  "results.debug.funnel.serverQuery": "Trechter-serverquery",
  "results.debug.funnel.noQuery": "Geen funnelquery geconfigureerd",
  "results.debug.funnel.sqlPlaceholder": "Configureer funnel-koppelingssleutel om SQL te genereren",
  "results.debug.funnel.stepsTitle": "Funnel Stappen",
  "results.debug.flow.label": "Flow-query",
  "results.debug.flow.badge": "{before} voor, {after} na",
  "results.debug.flow.serverQuery": "Flow-serverquery",
  "results.debug.flow.noQuery": "Geen flowquery geconfigureerd",
  "results.debug.flow.sqlPlaceholder": "Configureer flow om SQL te genereren",
  "results.debug.flow.configTitle": "Flow Configuratie",
  "results.debug.flow.startingStep": "Startende Stap:",
  "results.debug.flow.eventDimension": "Gebeurtenis Dimensie:",
  "results.debug.flow.stepsBefore": "Stappen Voor:",
  "results.debug.flow.stepsAfter": "Stappen Na:",
  "results.debug.flow.notSet": "Niet set",
  "results.debug.flow.responseTitle": "Server Response (Sankey Gegevens)",
  "results.debug.retention.label": "Retentie Query",
  "results.debug.retention.badge": "{segments} segment(en), {users} gebruikers",
  "results.debug.retention.serverQuery": "Retentie Server Query",
  "results.debug.retention.configIncomplete": "Configuratie Incomplete",
  "results.debug.retention.configHint": "Configureer de retentieanalyse-instellingen om een query te genereren.",
  "results.debug.retention.sqlPlaceholder": "Configureer retentie om SQL te genereren",
  "results.debug.retention.configTitle": "Retentie Configuratie",
  "results.debug.retention.summaryTitle": "Retentie Samenvatting",
  "results.debug.retention.retentionType": "Retentie Type:",
  "results.debug.retention.periods": "Periodes:",
  "results.debug.retention.granularity": "Granulariteit:",
  "results.debug.retention.segments": "Segmenten:",
  "results.debug.retention.avgPeriod1": "Avg Periode 1:",
  "results.debug.retention.maxPeriod1": "Max Periode 1:",
  "results.debug.retention.minPeriod1": "Min Periode 1:",
  "results.debug.standard.sqlPlaceholder": "Voeg metingen toe om SQL te genereren",
  "flow.tabs.flow": "Stroom",
  "flow.tabs.display": "Weergave",
  "flow.tabs.displayUnavailable": "Weergave options not beschikbaar",
  "flow.tabs.displayTitle": "Weergave options",
  "flow.visualization.title": "Visualisatie",
  "flow.visualization.description": "Kies hoe je de flowgegevens wilt visualiseren. Dit bepaalt hoe gegevens worden geaggregeerd.",
  "flow.visualization.sankey": "Sankey",
  "flow.visualization.sankeyHint": "Paden can converge",
  "flow.visualization.sunburst": "Sunburst",
  "flow.visualization.sunburstHint": "Unique paden alleen",
  "flow.startingStep.title": "Startende Stap",
  "flow.startingStep.description": "Define de anchor gebeurtenis van welke paden will zijn explored in both directions.",
  "flow.startingStep.filterLabel": "Filter Voorwaarden",
  "flow.depth.title": "Verkenningsdiepte",
  "flow.depth.descriptionSankey": "Hoe veel stappen naar explore voor en na de startende stap.",
  "flow.depth.descriptionSunburst": "Hoe veel stappen naar explore na de startende stap.",
  "flow.depth.stepsBefore": "Stappen Voor",
  "flow.depth.stepsBeforeNA": "(N/EEN)",
  "flow.depth.stepsAfter": "Stappen Na",
  "flow.depth.performanceWarning": "Hoog stap depth (4-5) kan impact query prestatie op groot datasets.",
  "flow.joinStrategy.title": "Join-strategie",
  "flow.joinStrategy.description": "Control hoe voor/na stappen zijn fetched. Schakel naar window if lateral is slower op je DB.",
  "flow.joinStrategy.auto": "Automatisch (prefer lateral if beschikbaar)",
  "flow.joinStrategy.lateral": "Lateraal (index-zoekacties)",
  "flow.joinStrategy.window": "Venster (ROW_NUMBER)",
  "retention.tabs.retention": "Retentie",
  "retention.tabs.display": "Weergave",
  "retention.tabs.displayUnavailable": "Weergave options not beschikbaar",
  "retention.tabs.displayTitle": "Weergave options",
  "retention.dateRange.title": "Datum Range",
  "retention.dateRange.description": "Selecteer het datumbereik voor cohort-instroom. Gebruikers die voor het eerst binnen dit bereik verschijnen worden geanalyseerd.",
  "retention.dateRange.label": "Datum Range",
  "retention.dateRange.selectRange": "Selecteer date range",
  "retention.dateRange.customRange": "Aangepast Range",
  "retention.dateRange.applyCustom": "Toepassen Aangepast Range",
  "retention.cohortFilter.title": "Cohortfilter",
  "retention.cohortFilter.description": "Bepaal wie tot het cohort behoort. Gebruikers waarvan de eerste gebeurtenis binnen het datumbereik aan deze filters voldoet, worden opgenomen.",
  "retention.returnFilter.title": "Terugkeerfilter",
  "retention.returnFilter.description": "Define what counts as a return. Gebeurtenissen matching these filters in subsequent periods count as retentie.",
  "retention.breakdown.title": "Opsplitsing",
  "retention.breakdown.description": "Optionally segment retentie by dimensies (e.g., country, plan type).",
  "retention.settings.title": "Instellingen",
  "retention.settings.description": "Configureer hoe retentie wordt berekend en weergegeven.",
  "retention.settings.granularityLabel": "Periode Granularity",
  "retention.settings.periodsLabel": "Nummer of Periods ({min}-{max})",
  "retention.settings.periodsWarning": "Hoog periode aantal kan impact query prestatie.",
  "retention.settings.retentionTypeLabel": "Retentie Type",
  "debug.explainPlan": "Uitleggen Plan",
  "debug.explainRunning": "Draaiend...",
  "debug.explainIncludeTiming": "Inclusief timing",
  "debug.explainRunningAnalyze": "Draaiend UITLEGGEN ANALYZE...",
  "debug.explainRunningBasic": "Draaiend UITLEGGEN...",
  "debug.explainError": "Explain Fout:",
  "debug.sequentialScans": "Sequentiële scans gedetecteerd",
  "debug.indexesUsed": "{count} index gebruikt",
  "debug.indexesUsedPlural": "{count} indexen gebruikt",
  "debug.executionTime": "Uitvoering: {time}ms",
  "debug.planningTime": "Planning: {time} ms",
  "debug.cost": "Kosten: {cost}",
  "debug.indexes": "Indexen:",
  "debug.executionPlanTitle": "Uitvoering Plan ({database})",
  "debug.aiAnalyzing": "Analyseren...",
  "debug.aiAnalysis": "AI Analyse",
  "debug.aiAnalysisError": "AI Analyse Fout:",
  "explainAI.title": "AI Performance Analyse",
  "explainAI.assessment.good": "Goed",
  "explainAI.assessment.warning": "Waarschuwing",
  "explainAI.assessment.critical": "Kritiek",
  "explainAI.summary": "Samenvatting",
  "explainAI.queryAnalysis": "Query Analyse",
  "explainAI.issuesFound": "Issues Gevonden ({count})",
  "explainAI.recommendations": "Aanbevelingen ({count})",
  "explainAI.noRecommendations": "Geen specifieke aanbevelingen. De query lijkt goed geoptimaliseerd.",
  "explainAI.expectedImpact": "Verwachte impact:",
  "explainAI.addToCube": "Voeg naar {cubeName} cube:",
  "explainAI.modelLabel": "Model:",
  "explainAI.usingUserKey": "(met je API sleutel)",
  "explainAI.copied": "Gekopieerd!",
  "explainAI.copy": "Kopiëren",
  "explainAI.type.index": "INDEX",
  "explainAI.type.table": "TABEL",
  "explainAI.type.cube": "CUBE",
  "explainAI.type.general": "TIP",
  "errorBoundary.modeError": "Mode Fout",
  "errorBoundary.modeErrorDescription": "Er is een probleem opgetreden met de modus {mode}. Dit kan komen door ongeldige configuratiegegevens.",
  "errorBoundary.showDetails": "Toon fout details",
  "errorBoundary.unknownError": "Onbekend fout",
  "errorBoundary.tryAgain": "Opnieuw proberen",
  "errorBoundary.switchToQuery": "Schakel naar Query Modus",
  "funnel.tabs.steps": "Stappen",
  "funnel.tabs.display": "Weergave",
  "funnel.tabs.displayUnavailable": "Weergave options not beschikbaar",
  "funnel.tabs.displayTitle": "Weergave options",
  "funnel.steps.title": "Funnel Stappen",
  "funnel.steps.emptyMessage": "Geen stappen defined. Voeg at least 2 stappen naar create a funnel.",
  "funnel.steps.addFirst": "Voeg First Stap",
  "funnel.steps.addStep": "Voeg Stap",
  "funnel.steps.validationHint": "Voeg at least one more stap naar create a valid funnel",
  "funnel.step.removeTitle": "Verwijderen stap",
  "funnel.step.editNameTitle": "Klik naar edit naam",
  "funnel.step.placeholder": "Stap name",
  "funnel.step.timeWindow": "Tijd Window",
  "funnel.step.timeWindowHelp": "Max tijd van previous stap naar qualify",
  "funnel.step.filters": "{count} filter",
  "funnel.step.filtersPlural": "{count} filters",
  "funnel.step.within": "binnen {time}",
  "funnel.step.noFilters": "Geen filters geconfigureerd",
  "funnel.config.configuration": "Configuratie",
  "funnel.config.cube": "Cube",
  "funnel.config.cubeHelp": "Selecteer een cube die is geconfigureerd voor funnelanalyse",
  "funnel.config.cubePlaceholder": "Selecteer gebeurtenis stream cube",
  "funnel.config.bindingKey": "Koppeling Sleutel",
  "funnel.config.bindingKeyHelp": "Entity dat connects stappen (e.g., gebruiker ID, order ID)",
  "funnel.config.bindingKeyPlaceholder": "Selecteer binding key",
  "funnel.config.selectCubeFirst": "Selecteer cube first",
  "funnel.config.timeDimension": "Tijd Dimensie",
  "funnel.config.timeDimensionHelp": "Tijdstempel veld voor stap ordering",
  "funnel.config.timeDimensionPlaceholder": "Selecteer time dimensie",
  "funnel.config.noMatchingFields": "Geen matching velden gevonden",
  "funnel.bindingKey.searchPlaceholder": "Zoeken dimensies...",
  "funnel.bindingKey.noMatching": "Geen matching dimensies gevonden",
  "funnel.bindingKey.helpText": "Selecteer een dimensie die entiteiten over funnelstappen identificeert (bijv. gebruikers-ID, order-ID)",
  "funnel.bindingKey.clearTitle": "Wissen binding key",
  "flow.config.configuration": "Configuratie",
  "flow.config.cube": "Cube",
  "flow.config.cubeHelp": "Selecteer een cube die is geconfigureerd voor flowanalyse",
  "flow.config.cubePlaceholder": "Selecteer gebeurtenis stream cube",
  "flow.config.bindingKey": "Koppeling Sleutel",
  "flow.config.bindingKeyHelp": "Entity dat links gebeurtenissen together (e.g., gebruiker ID)",
  "flow.config.bindingKeyPlaceholder": "Selecteer binding key",
  "flow.config.selectCubeFirst": "Selecteer cube first",
  "flow.config.timeDimension": "Tijd Dimensie",
  "flow.config.timeDimensionHelp": "Tijdstempel veld voor gebeurtenis ordering",
  "flow.config.timeDimensionPlaceholder": "Selecteer time dimensie",
  "flow.config.eventDimension": "Gebeurtenis Dimensie",
  "flow.config.eventDimensionHelp": "Dimensie dat categorizes gebeurtenissen (node labels in Sankey)",
  "flow.config.eventDimensionPlaceholder": "Selecteer gebeurtenis dimensie",
  "flow.config.noMatchingFields": "Geen matching velden gevonden",
  "retention.config.configuration": "Configuratie",
  "retention.config.cube": "Cube",
  "retention.config.cubeHelp": "Selecteer de cube met je gebruikersgebeurtenissen",
  "retention.config.cubePlaceholder": "Selecteer cube",
  "retention.config.bindingKey": "Koppeling Sleutel",
  "retention.config.bindingKeyHelp": "Dimensie die entiteiten over gebeurtenissen identificeert (bijv. gebruikers-ID, klant-ID)",
  "retention.config.bindingKeyPlaceholder": "Selecteer user identifier",
  "retention.config.selectCubeFirst": "Selecteer cube first",
  "retention.config.timestamp": "Tijdstempel",
  "retention.config.timestampHelp": "Tijdstempel veld voor cohort entry en activiteit",
  "retention.config.timestampPlaceholder": "Selecteer timestamp",
  "retention.config.noMatchingFields": "Geen matching velden gevonden",
  "retention.config.searchPlaceholder": "Zoeken...",
  "display.showLegend": "Toon Legenda",
  "display.showGrid": "Toon Grid",
  "display.showTooltip": "Toon Tooltip",
  "display.stacked": "Gestapeld",
  "display.hideHeader": "Verbergen Header",
  "fieldSearch.aria.closeDialog": "Sluiten dialog",
  "fieldSearch.aria.filterByCube": "Filter op cube",
  "fieldSearch.aria.cubeCategories": "Cube-categorieën",
  "fieldSearch.aria.availableFields": "Beschikbaar velden",
  "chart.dropZone.required": "Deze veld is vereist",
  "common.actions.apply": "Toepassen",
  "common.actions.done": "Klaar",
  "common.actions.update": "Bijwerken",
  "common.actions.retry": "Opnieuw proberen",
  "common.actions.exit": "Afsluiten",
  "common.actions.selectAll": "Selecteer Alle",
  "common.saving": "Opslaan...",
  "common.labels.title": "Titel",
  "dashboardFilter.editFilter": "Bewerken Filter",
  "dashboardFilter.filterLabel": "Filterlabel",
  "dashboardFilter.enterFilterLabel": "Enter filter label",
  "dashboardFilter.universalTimeFilter": "Universal Tijd Filter",
  "dashboardFilter.universalTimeDescription": "Dit filter wordt toegepast op alle tijdsdimensies in gekoppelde portlets. Gebruikers kunnen het datumbereik kiezen bij het bekijken van het dashboard.",
  "dashboardFilter.field": "Veld",
  "dashboardFilter.showDashboardFields": "Toon dashboard velden only",
  "dashboardFilter.showAllFields": "Toon alle velden",
  "dashboardFilter.dashboard": "Dashboard",
  "dashboardFilter.all": "Alle",
  "dashboardFilter.clickToSelectField": "Klik naar selecteer een veld",
  "dashboardFilter.operator": "Operator",
  "dashboardFilter.defaultValue": "Standaard Waarde",
  "dashboardFilter.deleteFilter": "Verwijderen Filter",
  "dashboardFilter.noValueRequired": "Geen waarde vereist",
  "dashboardFilter.to": "naar",
  "dashboardFilter.selectValue": "Selecteer waarde...",
  "dashboardFilter.search": "Zoeken...",
  "dashboardFilter.errorPrefix": "Fout:",
  "dashboardFilter.noValuesFound": "Geen waarden gevonden",
  "dashboardFilter.enterValue": "Enter waarde...",
  "dashboardFilter.enterNumber": "Enter nummer",
  "dashboardFilter.min": "Min",
  "dashboardFilter.max": "Max",
  "dashboardFilter.filterLabelRequired": "Filter label is vereist",
  "dashboardFilter.selectFieldRequired": "Selecteer een veld voor het filter",
  "dashboardFilter.notSet": "(niet set)",
  "dashboardFilter.clickToConfigure": "Klik om te configureren",
  "dashboardFilter.customDate.startDate": "Start Datum",
  "dashboardFilter.customDate.endDate": "End Datum",
  "dashboardFilter.customDate.sinceDate": "Since Datum",
  "dashboardFilter.customDate.fromSelectedToToday": "Van selected date naar today",
  "dashboardFilter.customDate.number": "Nummer",
  "dashboardFilter.customDate.unit": "Eenheid",
  "dashboardFilter.customDate.lastNPreview": "Laatste {number} {unit}",
  "dashboardFilter.editMode.filters": "Filters",
  "dashboardFilter.editMode.noFilters": "Geen filters geconfigureerd. Klik op \"Voeg toe\" om er één te maken.",
  "dashboardFilter.editMode.dateRange": "Datum Range",
  "dashboardFilter.editMode.filter": "Filter",
  "dashboardFilter.editMode.editFilter": "Bewerken filter",
  "dashboardFilter.editMode.removeFilter": "Verwijderen filter",
  "dashboardFilter.filterValue.editValue": "Bewerken waarde",
  "dashboardFilter.readOnly.filters": "Filters",
  "filter.shared.fieldsInQuery": "Velden in Query ({count})",
  "filter.shared.allAvailableFields": "Alle Beschikbaar Velden ({count})",
  "filter.shared.noFieldsMatch": "Geen velden gevonden matching \"{searchTerm}\"",
  "filter.shared.searchFields": "Zoeken velden...",
  "filter.shared.selectField": "Selecteer veld...",
  "filter.shared.schemaNotLoaded": "Schema niet geladen",
  "filter.shared.group.addFilter": "Voeg Filter",
  "filter.shared.group.addAndGroup": "Voeg EN Groep",
  "filter.shared.group.addOrGroup": "Voeg OF Groep",
  "filter.shared.group.addCondition": "Voeg condition",
  "filter.shared.group.noConditions": "Geen conditions in deze groep.",
  "filter.shared.group.addFilterLink": "Voeg a filter",
  "filter.shared.builder.filters": "Filters ({count})",
  "filter.shared.builder.clearAll": "Wissen alle",
  "filter.shared.builder.addFilter": "Voeg Filter",
  "filter.shared.dateRange.title": "Datum Ranges ({count})",
  "filter.shared.dateRange.clearAll": "Wissen alle",
  "filter.shared.dateRange.addDateRange": "Voeg Datum Range",
  "filter.shared.dateRange.allHaveDateRanges": "Alle time dimensies already have date ranges",
  "filter.shared.valueSelector.noValueRequired": "Geen waarde vereist",
  "filter.shared.valueSelector.to": "naar",
  "filter.shared.valueSelector.min": "Min",
  "filter.shared.valueSelector.max": "Max",
  "filter.shared.valueSelector.enterNumber": "Enter nummer",
  "filter.shared.valueSelector.loadingValues": "Laden waarden...",
  "filter.shared.valueSelector.selectValue": "Selecteer waarde...",
  "filter.shared.valueSelector.searchValues": "Zoeken waarden...",
  "filter.shared.valueSelector.searching": "Searching...",
  "filter.shared.valueSelector.errorLoading": "Fout laden waarden: {error}",
  "filter.shared.valueSelector.noMatchingValues": "Geen matching waarden",
  "filter.shared.valueSelector.noValuesAvailable": "Geen waarden beschikbaar",
  "filter.shared.valueSelector.enterValue": "Enter {type} waarde",
  "dashboard.noPortlets": "Geen Portlets",
  "dashboard.noPortletsDescription": "Voeg je first portlet naar start visualizing je gegevens",
  "dashboard.addText": "Voeg Tekst",
  "dashboard.addPortlet": "Voeg Portlet",
  "dashboard.finishEditing": "Finish Editing",
  "dashboard.edit": "Bewerken",
  "dashboard.grid": "Raster",
  "dashboard.rows": "Rijen",
  "dashboard.desktopRequired": "Desktop view vereist voor editing",
  "dashboard.editModeHint": "Drag • Resize • Automatisch-save",
  "dashboard.filterSelectionMode": "Filter Selection Modus - Klik portlets naar toggle '{filterLabel}'",
  "dashboard.filterSelectionEscHint": "• Druk op Enter of Esc om op te slaan",
  "dashboard.filterFieldChipHint": "Klik om te wijzigen op welk veld dit filter wordt toegepast voor deze portlet",
  "dashboard.editPortlet": "Bewerken Portlet",
  "dashboard.addNewPortlet": "Voeg Nieuw Portlet",
  "dashboard.updatePortlet": "Bijwerken Portlet",
  "dashboard.deletePortlet": "Verwijderen Portlet",
  "dashboard.deletePortletConfirm": "Zijn je sure je want naar verwijder",
  "dashboard.deletePortletSuffix": "? Deze action kan niet zijn undone.",
  "dashboard.thisPortlet": "deze portlet",
  "dashboard.editModal.dashboardName": "Dashboard Naam",
  "dashboard.editModal.enterDashboardName": "Enter dashboard naam...",
  "dashboard.editModal.descriptionOptional": "Beschrijving (optional)",
  "dashboard.editModal.enterDescription": "Enter description...",
  "portlet.configRequired": "Configuratie vereist",
  "portlet.configRequiredHint": "Configureer deze grafiek",
  "portlet.queryError": "Query Fout",
  "portlet.queryWithFilters": "Query (met filters toegepast)",
  "portlet.chartConfig": "Grafiek Configuratie",
  "portlet.noDataAvailable": "Geen gegevens beschikbaar",
  "portlet.noDataDrilled": "Geen datapunten om weer te geven voor het huidige filter",
  "portlet.invalidQuery": "Ongeldig query of no results",
  "portlet.unsupportedChartType": "Unsupported grafiek type",
  "portlet.unableToRender": "Kan niet renderen grafiek",
  "portlet.enterTitle": "Enter portlet title...",
  "portlet.enterPortletTitle": "Voer een titel in voor de portlet.",
  "portlet.configureQuery": "Configureer een query voordat je opslaat.",
  "portlet.configureFlow": "Configureer de flowanalyse (binding key, tijdsdimensie, gebeurtenisdimensie en startstapfilter).",
  "portlet.configureRetention": "Configureer de retentieanalyse (binding key, tijdsdimensie en datumbereik).",
  "portlet.configureFunnel": "Alstublieft add at least two funnel stappen.",
  "portlet.addMetricOrBreakdown": "Alstublieft add at least one metric of breakdown naar je query.",
  "portlet.filterConfig.title": "Configureer dashboardfilters",
  "portlet.filterConfig.subtitle": "Kies which dashboard filters apply naar \"{portletTitle}\"",
  "portlet.filterConfig.noFilters": "Geen dashboard filters beschikbaar",
  "portlet.filterConfig.noFiltersHint": "Voeg eerst filters toe op dashboardniveau",
  "portlet.filterConfig.availableFilters": "Beschikbaar Filters",
  "portlet.filterConfig.selectedCount": "{selected} van {total} selected",
  "portlet.filterConfig.applied": "Toegepast",
  "portlet.filterConfig.noValue": "geen waarde",
  "portlet.filterConfig.complexFilter": "Complex filter",
  "portlet.filterConfig.groupFilter": "{type} groep met {count} filter",
  "portlet.filterConfig.groupFilterPlural": "{type} groep met {count} filters",
  "portlet.filterConfig.applyFilters": "Toepassen Filters",
  "portlet.filterConfig.applyToField": "Toepassen op veld",
  "portlet.filterConfig.applyToFieldDefault": "Standaard ({field})",
  "portlet.filterConfig.mappedTo": "Gekoppeld aan {field}",
  "portlet.filterConfig.mappedFieldMissing": "Het gekoppelde veld \"{field}\" is niet meer beschikbaar in het schema",
  "textPortlet.editText": "Bewerken Tekst",
  "textPortlet.addText": "Voeg Tekst",
  "textPortlet.markdownContent": "Markdown Content",
  "textPortlet.markdownHint": "Ondersteunt kopteksten (#), bold (**tekst**), italic (*tekst*), links ([tekst](url)), lists (- item), en horizontal rules (---).",
  "textPortlet.preview": "Voorbeeld",
  "debug.title": "Grafiek Debug Information",
  "debug.chartType": "Grafiek Type",
  "debug.fieldAnalysis": "Veld Analyse",
  "debug.chartConfig": "Grafiek Configuratie",
  "debug.displayConfig": "Weergave Configuratie",
  "debug.queryObject": "Query-object",
  "debug.dataSample": "Gegevens Sample (first 3 rijen)",
  "debug.cacheStatus": "Cachestatus",
  "debug.cacheHit": "Cache-hit",
  "debug.cachedAt": "Cached Bij:",
  "debug.ttl": "TTL:",
  "debug.ttlRemaining": "Resterende TTL:",
  "debug.freshQuery": "Nieuwe query",
  "debug.notFromCache": "Resultaat not served van cache",
  "debug.escToClose": "Druk",
  "debug.escKey": "ESC",
  "debug.toClose": "naar sluiten",
  "debug.tooltip": "Debug grafiek configuratie",
  "error.unableToRender": "Kan niet renderen grafiek",
  "error.unableToRenderNamed": "Kan niet renderen {title}",
  "error.renderDescription": "There was an fout rendering deze grafiek component. De fout details zijn shown onder.",
  "error.errorLabel": "Fout:",
  "error.typeLabel": "Type:",
  "error.portletConfig": "Portlet Configuratie",
  "error.cubeQuery": "Cube-query",
  "error.componentStack": "Componentstack",
  "error.tryAgain": "Opnieuw proberen",
  "drill.back": "Terug",
  "drill.goBackOneLevel": "Go back één level",
  "drill.returnToTop": "Return naar boven level",
  "drill.navigateTo": "Navigeer naar {label}",
  "drill.empty": "(leeg)",
  "analyticsPage.title": "Analysepagina - Komt in fase 4",
  "dataHistogram.average": "Gemiddelde van {count} waarden",
  "dataHistogram.valuesInRange": "{count} waarden in deze bereik",

  "mcp.status.connecting": "Verbinden...",
  "mcp.status.loading": "Laden...",
  "mcp.status.waiting": "Wachten op queryresultaten...",
  "mcp.error.connectionLabel": "Verbindingsfout:",
  "mcp.error.errorLabel": "Fout:",
  "mcp.error.noTextContent": "Geen tekstinhoud in resultaat",
  "mcp.error.invalidResultFormat": "Ongeldig resultaatformaat: data-array ontbreekt",
  "mcp.error.parseFailed": "Kon resultaat niet verwerken: {message}",
  "mcp.error.queryFailed": "Query mislukt: {message}",
  "mcp.footer.rows": "{count} rij",
  "mcp.footer.rowsPlural": "{count} rijen",
  "mcp.footer.measures": "{count} metriek",
  "mcp.footer.measuresPlural": "{count} metrieken",
  "mcp.footer.dimensions": "{count} dimensie",
  "mcp.footer.dimensionsPlural": "{count} dimensies"
}
